var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __pow = Math.pow;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var __privateWrapper = (obj, member, setter, getter) => ({
  set _(value) {
    __privateSet(obj, member, value, setter);
  },
  get _() {
    return __privateGet(obj, member, getter);
  }
});
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var _focused, _cleanup, _setup, _a, _online, _cleanup2, _setup2, _b, _gcTimeout, _c, _initialState, _revertState, _cache, _client, _retryer, _defaultOptions, _abortSignalConsumed, _Query_instances, dispatch_fn, _d, _queries, _e, _observers, _mutationCache, _retryer2, _Mutation_instances, dispatch_fn2, _f, _mutations, _scopes, _mutationId, _g, _queryCache, _mutationCache2, _defaultOptions2, _queryDefaults, _mutationDefaults, _mountCount, _unsubscribeFocus, _unsubscribeOnline, _h, _client2, _currentQuery, _currentQueryInitialState, _currentResult, _currentResultState, _currentResultOptions, _currentThenable, _selectError, _selectFn, _selectResult, _lastQueryWithDefinedData, _staleTimeoutId, _refetchIntervalId, _currentRefetchInterval, _trackedProps, _QueryObserver_instances, executeFetch_fn, updateStaleTimeout_fn, computeRefetchInterval_fn, updateRefetchInterval_fn, updateTimers_fn, clearStaleTimeout_fn, clearRefetchInterval_fn, updateQuery_fn, notify_fn, _j;
import { jsx } from "react/jsx-runtime";
import * as React from "react";
import React__default, { createContext, useContext, useMemo } from "react";
const version = "2.0.0";
const packageInfo = {
  version
};
const CONTENT_ASSET_CLIENT_ID = "8a2e72c0-6a4e-4095-bea5-5e1b40cfb809";
const CRM_CUSTOMER_SEARCH_API_KEY = "BrJWsPVJmr1GjaCunUk6e0jvTXlN5dfSZv4Qb_WTFDWyAzFuQBbp2A==";
const SANITY_API_TOKEN = (
  // eslint-disable-next-line sonarjs/no-hardcoded-secrets
  "skZmNX06pP1aWCOgKlmpHwrIc9V8kjlXHxj1dDeQWZOHtFjIAbAknQfD0FKmnai7dBzlQv5scW6kYWTiHWpl3dpax8TCzoJeRzprVccCwb4vv06RESYDlrmWA07sCMawARphVd72R6onVsQOz81gzprqkln3cln4iTprhpftTcKHhnN8C5IM"
);
const INSTRUMENTATION_KEY = "18318952-2210-4cc5-b3eb-a6d771ea3db4";
const SANITY_DATASET = {
  ACCEPTANCE: "acceptance",
  PRODUCTION: "production"
};
const SANITY_CONFIG = {
  sanityProjectId: "cepj2ofv",
  sanityDataset: SANITY_DATASET.ACCEPTANCE,
  sanityApiToken: "",
  sanityApiVersion: "2026-09-11"
};
const DEV_CONFIGS = __spreadProps(__spreadValues({
  sizePassportUrl: "https://tst.apim.suitsupply.com/measurements/api/",
  sizePassportPublicUrl: "https://tst.apim.suitsupply.com/public/measurementapi/",
  measurementsBffUrl: "https://tst.apim.suitsupply.com/measurements/bffapi/",
  contentAsset: "https://testing.suitsupply.com/s/EXT/dw/shop/v20_10/content_search",
  ocInstance: "https://testing.suitsupply.com",
  contentAssetClientId: CONTENT_ASSET_CLIENT_ID,
  storesSecretKey: "nNU6BMHWya",
  crmCustomerSearchApiKey: CRM_CUSTOMER_SEARCH_API_KEY,
  instrumentationKey: INSTRUMENTATION_KEY,
  measWebServer: "http://localhost:3333/api/",
  scanditLicense: "ASI1YSQ9DAVJGQn1Kgr+XU1DDRrI+rhIdVM4wWAG5SpjC1RJw2pUC0tY/Cv1Ry1SMiBo9X98xjTvFgt2w1GnqDBlQLjCME/S3VunbBgCebRdcAmjCVRJ9v1KFeG4XPKSnU0u2zpG6q5yQJxXLVTdmD94VI53Xz3c1msX5BJA5nf1TuV9/HLUNyhwsltwcgOtSHRInbFTf4IvGeG41S6sqVIoEjaaLjsA2g76/CFEHmkFAQ11ao3xmZClr9NfJsOwmTa8YQi98PmPa7IEQ4f6NtFjR4x4a9EDq3Sdd8ivCmfLjbRDoNCax0c9efXxNhtqvqSWkdZWcCFx1oYdxQ5/ffqreyZCCuZY2B8uDxei/LZV5tqW2cFKReFcZYO2GmTiPp0y4/BeOk2+O8mNYMlUMCWLz4o3QzX4WhLiIbLnJnGs6Mm745UGDTfYyF2s/+m1yNCxxc6bnJipJmYi13RhGZcQwZuFHmi5MPPBJH5K2I+qYWR9HOXbMpTsZG2w1uD3dsqYYpxxKe1DXBIPoUaJFlf5rlLbmbYbaDTIMks1CTqHKvJSurZuiS6O5+Xr6KXQYUnVsaY9F/QTekwvNenNoyqHR0Kb3JOny/rTPLKoQviE63kMQ3E3+Ig2XuHBWYrNQsUZUQzPa4QhCD9UutWAIkj98R6O1EVVd2Msoms39B1J3qgFhwakORqC64mZaGeu++ecaFl/L96TjEnbhnGZ0vbro64XEfLDm+uUguvLknAKkqLTOPsXItc57RmrJkS/+8GMorepiO5ElXheHulJbsUb4c0eA+taRcwpjJnoKcRrOFjQsvEdLGMClAIZl7zMYfGJsylJSCtD67Eay2IMVrb0xzZyAaNLjUDxnKMZuv4XlDgRxHi/VRX/RmHcl4Rb5OtKVgZtRAbZMBlX",
  alterationsGateway: "https://alterationsgateway.tst.suitapi.com/",
  alterationsApiMGateway: "https://tst.apim.suitsupply.com/public/alterationsapi/",
  growthBookKey: "sdk-HVwqlY1tccXQMSp"
}, SANITY_CONFIG), {
  cdnBaseUrl: "https://cdn.suitsupply.com"
});
const TST_CONFIGS = __spreadProps(__spreadValues({
  sizePassportUrl: "https://tst.apim.suitsupply.com/measurements/api/",
  sizePassportPublicUrl: "https://tst.apim.suitsupply.com/public/measurementapi/",
  measurementsBffUrl: "https://tst.apim.suitsupply.com/measurements/bffapi/",
  contentAsset: "https://testing.suitsupply.com/s/EXT/dw/shop/v20_10/content_search",
  ocInstance: "https://testing.suitsupply.com",
  contentAssetClientId: CONTENT_ASSET_CLIENT_ID,
  storesSecretKey: "nNU6BMHWya",
  crmCustomerSearchApiKey: CRM_CUSTOMER_SEARCH_API_KEY,
  instrumentationKey: INSTRUMENTATION_KEY,
  measWebServer: "https://meas-testing.vercel.app/api/",
  scanditLicense: "ASI1YSQ9DAVJGQn1Kgr+XU1DDRrI+rhIdVM4wWAG5SpjC1RJw2pUC0tY/Cv1Ry1SMiBo9X98xjTvFgt2w1GnqDBlQLjCME/S3VunbBgCebRdcAmjCVRJ9v1KFeG4XPKSnU0u2zpG6q5yQJxXLVTdmD94VI53Xz3c1msX5BJA5nf1TuV9/HLUNyhwsltwcgOtSHRInbFTf4IvGeG41S6sqVIoEjaaLjsA2g76/CFEHmkFAQ11ao3xmZClr9NfJsOwmTa8YQi98PmPa7IEQ4f6NtFjR4x4a9EDq3Sdd8ivCmfLjbRDoNCax0c9efXxNhtqvqSWkdZWcCFx1oYdxQ5/ffqreyZCCuZY2B8uDxei/LZV5tqW2cFKReFcZYO2GmTiPp0y4/BeOk2+O8mNYMlUMCWLz4o3QzX4WhLiIbLnJnGs6Mm745UGDTfYyF2s/+m1yNCxxc6bnJipJmYi13RhGZcQwZuFHmi5MPPBJH5K2I+qYWR9HOXbMpTsZG2w1uD3dsqYYpxxKe1DXBIPoUaJFlf5rlLbmbYbaDTIMks1CTqHKvJSurZuiS6O5+Xr6KXQYUnVsaY9F/QTekwvNenNoyqHR0Kb3JOny/rTPLKoQviE63kMQ3E3+Ig2XuHBWYrNQsUZUQzPa4QhCD9UutWAIkj98R6O1EVVd2Msoms39B1J3qgFhwakORqC64mZaGeu++ecaFl/L96TjEnbhnGZ0vbro64XEfLDm+uUguvLknAKkqLTOPsXItc57RmrJkS/+8GMorepiO5ElXheHulJbsUb4c0eA+taRcwpjJnoKcRrOFjQsvEdLGMClAIZl7zMYfGJsylJSCtD67Eay2IMVrb0xzZyAaNLjUDxnKMZuv4XlDgRxHi/VRX/RmHcl4Rb5OtKVgZtRAbZMBlX",
  alterationsGateway: "https://alterationsgateway.tst.suitapi.com/",
  alterationsApiMGateway: "https://tst.apim.suitsupply.com/public/alterationsapi/",
  growthBookKey: "sdk-HVwqlY1tccXQMSp"
}, SANITY_CONFIG), {
  cdnBaseUrl: "https://cdn.suitsupply.com"
});
const ACC_CONFIGS = __spreadProps(__spreadValues({
  sizePassportUrl: "https://acc.apim.suitsupply.com/measurements/api/",
  sizePassportPublicUrl: "https://acc.apim.suitsupply.com/public/measurementapi/",
  measurementsBffUrl: "https://acc.apim.suitsupply.com/measurements/bffapi/",
  contentAsset: "https://acceptance.suitsupply.com/s/EXT/dw/shop/v20_10/content_search",
  ocInstance: "https://acceptance.suitsupply.com",
  contentAssetClientId: CONTENT_ASSET_CLIENT_ID,
  storesSecretKey: "nNU6BMHWya",
  crmCustomerSearchApiKey: CRM_CUSTOMER_SEARCH_API_KEY,
  instrumentationKey: INSTRUMENTATION_KEY,
  measWebServer: "https://meas-acceptance.vercel.app/api/",
  scanditLicense: "AWll4Tc9H3R+PC4AHRd59gwAfJgOzU4+s31eYQUB4LdmPyFYYkUlu1FcVnoAJbxVM2qF6ihufn3rUOvnW3TE5uMcHgPfTsSxjXBsHrVaPt3GTz0Q9FZ1+kx6P8/ed9OpB1r2o1BMtZw9Zfo3Ti8dyztgwFXcUB4Zg1ViWVJHfQtxag3cR3iXDkteuuQvNaCq2F3SuAlNpfwmFimS0w3er79v2G5RJaG2eB7INigyqQAMD1fII9x3WpkR/RSRAvXfCfUkWYY6oRWEGIVwNpgVQLnxvosMGXitWzPNO0hfnJJpYA2pDIWSi5Gx0A8onO59zi6Fs0T/FpOhhfAneQKQXkPiXU2J4nxXAsQMYqbNA3Yc2USDAE/beIsW4bW8PiFHyL/X8ryI2PstBvcTJIc946kiClVvbsuLOKKslH1GOU/pcBl3TuvaA6aDRh9B0+QiBMYXpkZLDhh0YnEGnB4xZVhrqJYL4kdQSnlhaJcAxCR4yZae+PcBogM/2uLCOMgyM3uXhrrfSzQ5XZ+mmClV5nMNggfPoxSi4emzpw9DCgk4n7X89tm/8399kgEkFcgNkJq01Ltzw6etjE/K56vAaeNy8Y4fe7s8i9L4FBIDZEX/8Ym6bQ1YlA+61bdBoIedzcR8wFr+ZxuPb/CAZgsWNogY96K/PvTgySA0RQ0DeALgbM9WcalqGDQxL5vndy4Hkj2Ab7BShXhAFvF+nfYCaCWVuEpkcazuFO7/26n6CxBujS6hlgG4snwHjwr1KOUL6yZ1780vCTOAWr3Vao6pickfGrqTfg0Ad4c98I4jcXJEJCoq0Q3FagF1pZVX8t9bDIKpr/qnt17FkgAhQ2n2PDTAjTj7+ZGMzOVK8SxYrwgPovT2agV9E3yWzffD4bumHAACTilYXd/H+h/Hw7j3K2qO",
  alterationsGateway: "https://alterationsgateway.acc.suitapi.com/",
  alterationsApiMGateway: "https://acc.apim.suitsupply.com/public/alterationsapi/",
  growthBookKey: "sdk-tmR6G1ujnruVE1g"
}, SANITY_CONFIG), {
  cdnBaseUrl: "https://cdn.suitsupply.com"
});
const PRD_CONFIGS = __spreadProps(__spreadValues({
  sizePassportUrl: "https://apim.suitsupply.com/measurements/api/",
  sizePassportPublicUrl: "https://apim.suitsupply.com/public/measurementapi/",
  measurementsBffUrl: "https://apim.suitsupply.com/measurements/bffapi/",
  contentAsset: "https://suitsupply.com/s/EXT/dw/shop/v20_10/content_search",
  ocInstance: "https://suitsupply.com",
  contentAssetClientId: CONTENT_ASSET_CLIENT_ID,
  storesSecretKey: "QeX1G4FdJU",
  crmCustomerSearchApiKey: "WBnS0aMFgGilOtumuIv_CYxBp6xlfRwFppB9BR2DfyBfAzFuUMBOSA==",
  instrumentationKey: INSTRUMENTATION_KEY,
  measWebServer: "https://meas-production.vercel.app/api/",
  scanditLicense: "AVHleY2BGdzhErGwO0WPrYcwl4rGwZYoQnKPWhwPSexrNRycH1ooCnFq5p8QTMhoYUqmHGclf2zZQMHTPSeHIygJuY+ta4DO8FJh2CJVUQydb7ByckgTpQRw0UaaZh3w2mbZihpfoafHINvhk1djsSlGWP0yEl3HZVMfHIBA3NOoMpf8jAchC40C2iimCZZHPwsfbqgTWfc+HjH/z7orIoKNCO7vwYTy0NNVFIhwrDdjI6Ku9CfRiyDV9VCW8ar0uqVu+EcLp3WNsEhbi5UHb6ysZtZsq35rKofDAzbpIPIwT2hgkZP0kzBXbVCXvh63Z6ZGugN+MqubOR5JsS70hb70Cwz8Gw7g8LWjcav6Mvy9W6eAC6gZR4cgnXHT5fMBMuafVfHEcMlC+FML4W69TJAzg9Vv7akBQg2ylHusQ9adIuHSvwjlYEhaVKYXHD6FdIJ/Mvm9Pd8isQfXeICRCqtISlrNbZJ9Dx4GZ58t8K34UyMXdpyCycurvesPCDukveguByTVNqRpGBOx2x8ffW6eIDeCfMy8+sbjyHaOpso2+JKoDrr/6k0WkfyDV4C72fMZ8T1HxQIOiBDthCiSdhzDAoU1w14hrNrPVfv1JaEqVUNOriXXt25FgRRPk5kniQSnrzMmxakRqQMfZ2w/XdZzx2RWP9prrHNdBrQG8mu88kbrQNOF8exGgJezTjWpukLD1mU4T9l74QkeyMGWoOtE245Hczc4IEg04JQMx9E6Am6JIsEFnD6WHFkrCcPRVWgJo8I66ir5PGnIQELk6TZbiCyjoiRmLzMaOw9AuSvpOlHHBn8jJjN207FCtQGDM7l1yv2egeWRk+8JQlfmmybYOQ/yiNNKCZH9Pa0tfkojwiRqzt18NGLX",
  alterationsGateway: "https://alterationsgateway.suitapi.com/",
  alterationsApiMGateway: "https://apim.suitsupply.com/public/alterationsapi/",
  growthBookKey: "sdk-MDfwRAagxgVdlZL"
}, SANITY_CONFIG), {
  sanityDataset: SANITY_DATASET.PRODUCTION,
  sanityApiToken: SANITY_API_TOKEN,
  cdnBaseUrl: "https://cdn.suitsupply.com"
});
const CN_TST_CONFIGS = __spreadProps(__spreadValues({
  sizePassportUrl: "https://testing.apim.cn1.suitsupply.com/measurements/api/",
  sizePassportPublicUrl: "https://testing.apim.cn1.suitsupply.com/public/measurementapi/",
  measurementsBffUrl: "https://testing.apim.cn1.suitsupply.com/measurements/bffapi/",
  contentAsset: "https://testing.suitsupply.com/s/EXT/dw/shop/v20_10/content_search",
  ocInstance: "https://testing.suitsupply.com",
  contentAssetClientId: CONTENT_ASSET_CLIENT_ID,
  storesSecretKey: "nNU6BMHWya",
  crmCustomerSearchApiKey: CRM_CUSTOMER_SEARCH_API_KEY,
  instrumentationKey: INSTRUMENTATION_KEY,
  measWebServer: "https://monorepo-measurements-china-poc-tes.vercel.app/api/",
  scanditLicense: "ATUnIzu6EWCmKPbTnhB73Tc6t87F15XkX21CsLEz9C5WD/Hm9muxZKN+5DzBa2aSBHmB2mI+H5K7SHtzc3FzCi9g3d7rZGbBaVRj17gemac7Q++m7ljOrxBJiK9SW0DjhlCNteBHYWLBUIgG2WcoO4ZvXQ7uOaYVNFWOoJtCApy2WeDrTydAZ+Bf7Xu3Y5ekvSTCi1ld81OENZg0zySwcQQ8WWl3CEdK7xwfvWcUFqjxM8SNLNhC4SFXbI1rzNfzNaoQJCJQ5sVbNb4Kn1aF5j6MOA4V8qt4DlhQ4zwPOqO1wVjvWKquZkLDPAhbUemNIoOKk+h6J9xzNJGery6vNahWp48cE8nnAfpcUPJJYncpVsKFaBeRvt4IIR73StNWlfDGioxYZCOI0M76Fz6mLqf//TiiRHttHWEHxA7OK9lJJHet0H5DojGuhyHs+KLW1NFwvjLSPR/yw13ScWHXsjUBGiAHiS6/giNRU+z+PNo6bgFcZtECBh7aGZx4EIB217SvFFgqXvs5+co0JiuzcDz9LJyQHuKNOoZhWfLc+nF3FRCLNKtjcWLwARY6z18d63mA6WuYiSXNWzsBVLVgaflY3kgpcOedd8wHyFWuDwzApGpMF2SyfhHLJnG2vkp3sPskf7+/IFYxPSSjaW773v+NDgtUCKYqCapKhvpX4aJ/FCl812sv6Z3qqIxJ7EjA+FcdNR96FrzDMo4GwYIj7sYGhU9/e2o2kl6W0TmfsADRujVOtgt/DidWhkOA4b5ERRefCDSpGKLgZ3qV5ASbH5/QXOdS3ymSFwG2yNvweFPXxEN6k+UTsQztrD68Pi5HhPeM1YUZa264BU3Ms8HDz7ANTUPmMI50ft9PoRHbIdkgIPwOwIR75APxayL5c3DzbImSgy8w9QP9SN7RRDwpoXrB",
  alterationsGateway: "https://alterationsgateway.tst.suitapi.com/",
  alterationsApiMGateway: "https://testing.apim.cn1.suitsupply.com/public/alterationsapi/",
  growthBookKey: "sdk-HVwqlY1tccXQMSp"
}, SANITY_CONFIG), {
  cdnBaseUrl: "https://cdn.cn1.suitsupply.com"
});
const CN_PRD_CONFIGS = __spreadProps(__spreadValues({
  sizePassportUrl: "https://apim.cn1.suitsupply.com/measurements/api/",
  sizePassportPublicUrl: "https://apim.cn1.suitsupply.com/public/measurementapi/",
  measurementsBffUrl: "https://apim.cn1.suitsupply.com/measurements/bffapi/",
  contentAsset: "https://suitsupply.com/s/EXT/dw/shop/v20_10/content_search",
  ocInstance: "https://suitsupply.com",
  contentAssetClientId: CONTENT_ASSET_CLIENT_ID,
  storesSecretKey: "QeX1G4FdJU",
  crmCustomerSearchApiKey: "WBnS0aMFgGilOtumuIv_CYxBp6xlfRwFppB9BR2DfyBfAzFuUMBOSA==",
  instrumentationKey: INSTRUMENTATION_KEY,
  measWebServer: "https://meas-cn.vercel.app/api/",
  scanditLicense: "AZeHybiBLHLHIofYlxfC5Xg7yFwZ0ZnSkE3NW044e/awNWdt/1NY3vRQY4kcSBZMsRsug/pmoWgaXIyK/Ens749UWcsRXvzLoULQOLZLFcnERQmRZAVmpPE3yySEUOfUSW8J4VdCqUmFT0XC6mMBSwBewafJbvqhCmmXCMcLJVTlaA8N0FTzhTtYG4INLPOqUS+xhCYkdgFyJFPdZgAGlrtNkb/bXnKbRUdu5xf0cv3HEfqJcmK0kEruQ9dC6Z+JluqfLMqulq6jinfSWGKUy0in+RWAQgL2qN82a9wODCYwEmej7O/rPyC1TmWTQoXa0QWKVsCXWJxCm41aroUQa6tHMbRPK76yf++YOY7ZkJudsskQ/lfzcliidOxWlmO507BIvNadgycKKWoxQYQYwtRN6r5QTCAHLAoUVyzd1VmXZfCI7Yu3KxG+sQ/lwH2lFDgh3O1g5PLlG4KKaqJ9P52RGEdWL9YAAtQzE9R+uVdcD4eapwK256UkS9XhM2AEn+KUVWilM5YiJjI7O2GRrpUV50J8sOVvRc3aw9sOd8XjqkOz+AAl6uYknJNL1c1kRNhH5laqFXz8p+nwoVeBvN3OYq5jq6Je3RrTTn7xGAtjqM9sk5F8Ay0RTUIbBEc4tHGyYZtBNWQFtyNYbKkQVt4AuPLNP+VtNetcWedoETXUA72NGdgEv8HYzXZrMsE3A/dkoZ1cOtiVBNBrFXNXpzL64oBYpPuP0hAu+5CY4gEp5/52uM/urdf1o/a5/HePvz+h+15kqHdPeGPthd52Oh6VeOKmc1GXmY40GrnqCYdbIjMApWJewAHZww8gNapq2q3oif9xXkxmbTSkY2vTe5nbv6TfshObdBKpz/NWjsO59rxuUT7ddtqjglUHK1Cz",
  alterationsGateway: "https://alterationsgateway.suitapi.com/",
  alterationsApiMGateway: "https://apim.cn1.suitsupply.com/public/alterationsapi/",
  growthBookKey: "sdk-MDfwRAagxgVdlZL"
}, SANITY_CONFIG), {
  sanityDataset: SANITY_DATASET.PRODUCTION,
  sanityApiToken: SANITY_API_TOKEN,
  cdnBaseUrl: "https://cdn.cn1.suitsupply.com"
});
const MEAS_ENV_CONFIG = {
  dev: DEV_CONFIGS,
  tst: TST_CONFIGS,
  acc: ACC_CONFIGS,
  prd: PRD_CONFIGS,
  cn_tst: CN_TST_CONFIGS,
  cn_prd: CN_PRD_CONFIGS
};
let MEAS_INTERNAL_CONFIG_STORE = null;
const getMeasClientVersion = () => {
  return packageInfo.version;
};
const getMeasEnvBasedConfig = (env) => {
  return MEAS_ENV_CONFIG[env];
};
const getMeasInternalConfig = () => {
  if (!MEAS_INTERNAL_CONFIG_STORE) {
    throw new Error("Internal config is not initialized. Please ensure internal config utils used within mounted flows.");
  }
  return MEAS_INTERNAL_CONFIG_STORE;
};
const setMeasInternalConfig = (config) => {
  MEAS_INTERNAL_CONFIG_STORE = config;
};
const ConfigStateContext = createContext(null);
const useMainConfigContext = () => {
  const context = useContext(ConfigStateContext);
  if (!context) {
    throw new Error("useMainConfigContext must be used within a ConfigStateContext.Provider");
  }
  return {
    config: context,
    packageVersion: packageInfo.version
  };
};
function CommonConfigProvider({
  children,
  env
}) {
  const contextValue = useMemo(() => {
    const appVersion = getMeasClientVersion();
    console.info(`MEAS_APPLICATION, ${appVersion}`);
    const combinedConfig = {
      environment: env,
      version: appVersion,
      envBased: MEAS_ENV_CONFIG[env]
    };
    setMeasInternalConfig(combinedConfig);
    return combinedConfig;
  }, [env]);
  return /* @__PURE__ */ jsx(ConfigStateContext.Provider, { value: contextValue, children });
}
const customDevOnlyLogger = (log, level = "info") => {
  const env = getMeasInternalConfig().environment;
  if (env === "dev" || env === "tst") {
    customMessageLogger(log, level);
  }
};
const customMessageLogger = ({
  message,
  data
}, level = "warn") => {
  const isDataPresent = data !== void 0 && data !== null;
  switch (level) {
    case "log":
      isDataPresent ? console.log(message, data) : console.log(message);
      break;
    case "info":
      isDataPresent ? console.info(message, data) : console.info(message);
      break;
    case "warn":
      isDataPresent ? console.warn(message, data) : console.warn(message);
      break;
    case "error":
      isDataPresent ? console.error(message, data) : console.error(message);
      break;
    case "count":
      console.count(message);
      break;
  }
};
const byteToHex = [];
for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 256).toString(16).slice(1));
}
function unsafeStringify(arr, offset = 0) {
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    if (typeof crypto === "undefined" || !crypto.getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    getRandomValues = crypto.getRandomValues.bind(crypto);
  }
  return getRandomValues(rnds8);
}
const randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const native = { randomUUID };
function v4(options, buf, offset) {
  var _a2, _b2, _c2;
  if (native.randomUUID && true && !options) {
    return native.randomUUID();
  }
  options = options || {};
  const rnds = (_c2 = (_b2 = options.random) != null ? _b2 : (_a2 = options.rng) == null ? void 0 : _a2.call(options)) != null ? _c2 : rng();
  if (rnds.length < 16) {
    throw new Error("Random bytes length must be >= 16");
  }
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  return unsafeStringify(rnds);
}
const isBrowser = () => typeof window !== "undefined";
const getDatadogLogs = () => __async(null, null, function* () {
  var _a2;
  if (!isBrowser()) {
    throw new Error("Datadog Logs is only available in the browser");
  }
  if ((_a2 = window == null ? void 0 : window.DD_LOGS) == null ? void 0 : _a2.getInitConfiguration()) {
    return window.DD_LOGS;
  }
  const {
    datadogLogs: datadogLogs2
  } = yield import("./main-BNpnrhsL.js");
  return datadogLogs2;
});
const getDatadogRum = () => __async(null, null, function* () {
  var _a2;
  if (!isBrowser()) {
    throw new Error("Datadog RUM is only available in the browser");
  }
  if ((_a2 = window == null ? void 0 : window.DD_RUM) == null ? void 0 : _a2.getInitConfiguration()) {
    return window.DD_RUM;
  }
  const {
    datadogRum: datadogRum2
  } = yield import("./main-B9eNbpdi.js").then((n) => n.A);
  return datadogRum2;
});
var fullPattern = " daum[ /]| deusu/|(?:^|[^g])news(?!sapphire)|(?<! (?:channel/|google/))google(?!(app|/google| pixel))|(?<! cu)bots?(?:\\b|_)|(?<!(?:lib))http|(?<![hg]m)score|(?<!cam)scan|24x7|@[a-z][\\w-]+\\.|\\(\\)|\\.com\\b|\\b\\w+\\.ai|\\bmanus-user/|\\bort/|\\bperl\\b|\\bsecurityheaders\\b|\\btime/|\\||^[\\w \\.\\-\\(?:\\):%]+(?:/v?\\d+(?:\\.\\d+)?(?:\\.\\d{1,10})*?)?(?:,|$)|^[^ ]{50,}$|^\\d+\\b|^\\W|^\\w*search\\b|^\\w+/[\\w\\(\\)]*$|^\\w+/\\d\\.\\d\\s\\([\\w@]+\\)$|^active|^ad muncher|^amaya|^apache/|^avsdevicesdk/|^azure|^biglotron|^bot|^bw/|^clamav[ /]|^client/|^cobweb/|^custom|^ddg[_-]android|^discourse|^dispatch/\\d|^downcast/|^duckduckgo|^email|^facebook|^getright/|^gozilla/|^hobbit|^hotzonu|^hwcdn/|^igetter/|^jeode/|^jetty/|^jigsaw|^microsoft bits|^movabletype|^mozilla/\\d\\.\\d\\s[\\w\\.-]+$|^mozilla/\\d\\.\\d\\s\\(compatible;?(?:\\s[\\w\\d-.]+\\/\\d+\\.\\d+)?\\)$|^navermailapp|^netsurf|^offline|^openai/|^owler|^php|^postman|^python|^rank|^read|^reed|^rest|^rss|^snapchat|^space bison|^svn|^swcd |^taringa|^thumbor/|^track|^w3c|^webbandit/|^webcopier|^wget|^whatsapp|^wordpress|^xenu link sleuth|^yahoo|^yandex|^zdm/\\d|^zoom marketplace/|advisor|agent\\b|analyzer|archive|ask jeeves/teoma|audit|bit\\.ly/|bluecoat drtr|browsex|burpcollaborator|capture|catch|check\\b|checker|chrome-lighthouse|chromeframe|classifier|cloudflare|convertify|crawl|cypress/|dareboost|datanyze|dejaclick|detect|dmbrowser|download|exaleadcloudview|feed|fetcher|firephp|functionize|grab|headless|httrack|hubspot marketing grader|ibisbrowser|infrawatch|insight|inspect|iplabel|java(?!;)|library|linkcheck|mail\\.ru/|manager|measure|monitor\\b|neustar wpm|node\\b|nutch|offbyone|onetrust|optimize|pageburst|pagespeed|parser|phantomjs|pingdom|powermarks|preview|proxy|ptst[ /]\\d|retriever|rexx;|rigor|rss\\b|scrape|server|sogou|sparkler/|speedcurve|spider|splash|statuscake|supercleaner|synapse|synthetic|tools|torrent|transcoder|url|validator|virtuoso|wappalyzer|webglance|webkit2png|whatcms/|xtate/";
var naivePattern = /bot|crawl|http|lighthouse|scan|search|spider/i;
var pattern;
function getPattern() {
  if (pattern instanceof RegExp) {
    return pattern;
  }
  try {
    pattern = new RegExp(fullPattern, "i");
  } catch (error) {
    pattern = naivePattern;
  }
  return pattern;
}
function isbot(userAgent) {
  return Boolean(userAgent) && getPattern().test(userAgent);
}
function isBotSession() {
  return isBrowser() && isbot(navigator.userAgent);
}
const PLATFORMS = [
  "shopify",
  "sfcc",
  "buyquickly",
  "predictspring",
  // In-store retail (RP) tooling: booking-tool, check-in, check-out,
  // customer-profile, customer-search. Used inside stores, not customer-facing.
  "instore",
  "tailor-instructions"
];
const ENVIRONMENTS = ["prd", "tst", "acc", "dev"];
const RESERVED_TAG_KEYS = ["platform", "env", "country", "domain", "sub_service"];
const requiredStringErrors = (config) => {
  const requiredStrings = ["service", "version", "applicationId", "clientToken"];
  return requiredStrings.filter((field) => {
    const value = config[field];
    return typeof value !== "string" || value.trim() === "";
  }).map((field) => `"${field}" is required and must be a non-empty string`);
};
const optionalFieldErrors = (config) => {
  const errors = [];
  if (config.country !== void 0 && (typeof config.country !== "string" || config.country.trim() === "")) {
    errors.push('"country" must be a non-empty string when provided. Omit the field for apps not tied to a single country.');
  }
  const id = config.locationId;
  if (id !== void 0 && (typeof id !== "number" || !Number.isInteger(id) || id < 0)) {
    errors.push(`"locationId" must be a non-negative integer when provided. Received: ${String(id)}`);
  }
  return errors;
};
const enumErrors = (config) => {
  const errors = [];
  if (!ENVIRONMENTS.includes(config.env)) {
    errors.push(`"env" must be one of: ${ENVIRONMENTS.join(", ")}. Received: "${String(config.env)}"`);
  }
  if (!PLATFORMS.includes(config.platform)) {
    errors.push(`"platform" must be one of: ${PLATFORMS.join(", ")}. Received: "${String(config.platform)}"`);
  }
  return errors;
};
const sampleRateErrors = (config) => {
  const optionalSampleRates = ["sessionSampleRate", "sessionReplaySampleRate", "logsSampleRate"];
  return optionalSampleRates.filter((field) => {
    const value = config[field];
    return value !== void 0 && (typeof value !== "number" || !Number.isFinite(value) || value < 0 || value > 100);
  }).map((field) => `"${field}" must be a finite number between 0 and 100. Received: ${String(config[field])}`);
};
const additionalTagErrors = (config) => {
  if (!config.additionalTags) return [];
  const reservedConflicts = Object.keys(config.additionalTags).filter((key) => RESERVED_TAG_KEYS.includes(key));
  if (reservedConflicts.length === 0) return [];
  return [`"additionalTags" cannot reuse reserved keys: ${reservedConflicts.join(", ")}. These tags are owned by the package and set from the validated config: ${RESERVED_TAG_KEYS.join(", ")}`];
};
function validateConfig(config) {
  const errors = [...requiredStringErrors(config), ...optionalFieldErrors(config), ...enumErrors(config), ...sampleRateErrors(config), ...additionalTagErrors(config)];
  if (errors.length > 0) {
    throw new Error(`Datadog configuration validation failed:
- ${errors.join("\n- ")}`);
  }
}
function applyDatadogGlobalContextTags(instance, {
  platform,
  env,
  country,
  locationId,
  additionalTags,
  subService
}) {
  instance.setGlobalContextProperty("platform", platform);
  instance.setGlobalContextProperty("env", env);
  if (country !== void 0) {
    instance.setGlobalContextProperty("country", country);
  }
  if (locationId !== void 0) {
    instance.setGlobalContextProperty("location_id", locationId);
  }
  if (subService !== void 0) {
    instance.setGlobalContextProperty("sub_service", subService);
  }
  if (additionalTags) {
    const tags = Object.entries(additionalTags);
    for (const [key, value] of tags) {
      instance.setGlobalContextProperty(key, value);
    }
  }
}
const TREE_KEY = "__susuDDContextTree";
function getTree() {
  const global = globalThis;
  if (!global[TREE_KEY]) {
    global[TREE_KEY] = {
      registry: /* @__PURE__ */ new Map(),
      leaf: null
    };
  }
  return global[TREE_KEY];
}
function findNearestActiveAncestor(node) {
  let current = node.parent;
  while (current !== null && !current.isActive) {
    current = current.parent;
  }
  return current;
}
function initDatadogRum(config) {
  return __async(this, null, function* () {
    validateConfig(config);
    const {
      service,
      env,
      version: version2,
      applicationId,
      clientToken,
      site = "datadoghq.eu",
      sessionSampleRate,
      sessionReplaySampleRate,
      trackUserInteractions = true,
      trackResources = true,
      trackLongTasks = true,
      defaultPrivacyLevel = "mask-user-input",
      storeContextsAcrossPages,
      useSecureSessionCookie,
      platform,
      subService,
      country,
      locationId,
      additionalTags,
      rumBeforeSend
    } = config;
    const rum = yield getDatadogRum();
    if (!rum.getInitConfiguration()) {
      const isBot = isBotSession();
      rum.init({
        applicationId,
        clientToken,
        site,
        service,
        env,
        version: version2,
        sessionSampleRate: isBot ? 0 : sessionSampleRate,
        sessionReplaySampleRate: isBot ? 0 : sessionReplaySampleRate,
        trackUserInteractions,
        trackResources,
        trackLongTasks,
        defaultPrivacyLevel,
        storeContextsAcrossPages,
        useSecureSessionCookie,
        beforeSend: rumBeforeSend
      });
    }
    applyDatadogGlobalContextTags(rum, {
      platform,
      env,
      country,
      locationId,
      additionalTags,
      subService
    });
    return rum;
  });
}
function initDatadogLogs(config) {
  return __async(this, null, function* () {
    validateConfig(config);
    const {
      service,
      env,
      version: version2,
      clientToken,
      site = "datadoghq.eu",
      logsSampleRate,
      forwardErrorsToLogs = true,
      storeContextsAcrossPages,
      useSecureSessionCookie,
      subService,
      platform,
      country,
      locationId,
      additionalTags,
      logsBeforeSend
    } = config;
    const logs = yield getDatadogLogs();
    if (!logs.getInitConfiguration()) {
      logs.init({
        clientToken,
        site,
        service,
        env,
        version: version2,
        sessionSampleRate: isBotSession() ? 0 : logsSampleRate,
        forwardErrorsToLogs,
        storeContextsAcrossPages,
        useSecureSessionCookie,
        beforeSend: logsBeforeSend
      });
    }
    applyDatadogGlobalContextTags(logs, {
      platform,
      env,
      country,
      locationId,
      additionalTags,
      subService
    });
    return logs;
  });
}
function initDatadog$1(config) {
  return __async(this, null, function* () {
    const [preRum, preLogs] = yield Promise.all([getDatadogRum(), getDatadogLogs()]);
    const rumPreSnapshot = __spreadValues({}, preRum.getGlobalContext());
    const logsPreSnapshot = __spreadValues({}, preLogs.getGlobalContext());
    const [rum, logs] = yield Promise.all([initDatadogRum(config), initDatadogLogs(config)]);
    if (!config.subService) {
      rum.setGlobalContextProperty("domain", config.service);
      logs.setGlobalContextProperty("domain", config.service);
    }
    const id = Symbol();
    const restore = () => {
      rum.setGlobalContext(__spreadValues({}, rumPreSnapshot));
      logs.setGlobalContext(__spreadValues({}, logsPreSnapshot));
      applyDatadogGlobalContextTags(rum, config);
      applyDatadogGlobalContextTags(logs, config);
      if (!config.subService) {
        rum.setGlobalContextProperty("domain", config.service);
        logs.setGlobalContextProperty("domain", config.service);
      }
    };
    const tree = getTree();
    const node = {
      id,
      parent: tree.leaf,
      isActive: true,
      restore
    };
    tree.registry.set(id, node);
    tree.leaf = node;
    const cleanup = () => {
      if (!node.isActive) return;
      const t = getTree();
      node.isActive = false;
      t.registry.delete(id);
      const effectiveParent = findNearestActiveAncestor(node);
      for (const n of t.registry.values()) {
        if (n.parent === node) {
          n.parent = effectiveParent;
        }
      }
      if (t.leaf === node) {
        t.leaf = effectiveParent;
        if (effectiveParent) {
          effectiveParent.restore();
        } else {
          rum.setGlobalContext(__spreadValues({}, rumPreSnapshot));
          logs.setGlobalContext(__spreadValues({}, logsPreSnapshot));
        }
      }
    };
    return {
      rum,
      logs,
      cleanup
    };
  });
}
const DATADOG_INIT_CONFIG = {
  appId: "bc66c8cf-2c0c-4b61-8eac-3768392b7c69",
  publicToken: "pub29eb2f316c6a9c25710cd22c08d6de32"
};
const DATADOG_INIT_VARIATIONS_CONFIG = {
  site: "datadoghq.eu",
  service: {
    main: "sizepassport"
  },
  sessionSampleRate: {
    dev: 20,
    tst: 30,
    acc: 30,
    prd: 100
  },
  sessionReplaySampleRate: {
    dev: 10,
    tst: 10,
    acc: 10,
    prd: 20
  }
};
let datadogRum;
let datadogLogs;
function getDatadogUser() {
  if (datadogRum == null ? void 0 : datadogRum.getInitConfiguration()) {
    return datadogRum.getUser();
  }
  return void 0;
}
function getIsDatadogInitialized() {
  return !!(datadogRum == null ? void 0 : datadogRum.getInitConfiguration());
}
function getIsDatadogLogsInitialized() {
  return !!(datadogLogs == null ? void 0 : datadogLogs.getInitConfiguration());
}
function trackDatadogActions({
  eventDetails,
  eventName,
  eventType = "info"
}) {
  if (datadogRum == null ? void 0 : datadogRum.getInitConfiguration()) {
    customDevOnlyLogger({
      message: `DataDog Action Triggered ${eventName}`,
      data: __spreadValues({
        type: eventType
      }, eventDetails)
    });
    datadogRum.addAction(eventName, __spreadValues({
      sub_service: DATADOG_INIT_VARIATIONS_CONFIG.service.main,
      type: eventType
    }, eventDetails));
  }
}
function trackDatadogLogs({
  eventDetails,
  eventName,
  eventType = "info"
}) {
  if (datadogLogs == null ? void 0 : datadogLogs.getInitConfiguration()) {
    const additionalDetails = eventDetails || {};
    customDevOnlyLogger({
      message: `DataDog Logger Triggered ${eventName}`,
      data: __spreadValues({}, additionalDetails)
    });
    const context = __spreadValues({
      sub_service: DATADOG_INIT_VARIATIONS_CONFIG.service.main
    }, additionalDetails);
    if (eventType === "error") {
      datadogLogs.logger.error(eventName, context);
    } else if (eventType === "warn") {
      datadogLogs.logger.warn(eventName, context);
    } else {
      datadogLogs.logger.info(eventName, context);
    }
  }
}
function createCustomDatadogLogger({
  loggerName,
  environment,
  eventType = "info"
}) {
  if (datadogLogs == null ? void 0 : datadogLogs.getInitConfiguration()) {
    customDevOnlyLogger({
      message: `DataDog Custom Logger Initialized ${loggerName}`
    });
    return datadogLogs.createLogger(`measurements:${loggerName}`, {
      level: eventType,
      context: {
        service: DATADOG_INIT_VARIATIONS_CONFIG.service.main,
        sub_service: DATADOG_INIT_VARIATIONS_CONFIG.service.main,
        env: mapLocalEnvToDatadogEnv(environment)
      }
    });
  }
  return void 0;
}
const mapLocalEnvToDatadogEnv = (env) => {
  var _a2;
  const map = {
    cn_tst: "tst",
    cn_prd: "prd"
  };
  return (_a2 = map[env]) != null ? _a2 : env;
};
const normalizeDatadogCountry = (countryCode) => (countryCode == null ? void 0 : countryCode.trim().toUpperCase()) || void 0;
function getDatadogConfig({
  env,
  appVersion,
  isStorageDisabled,
  client,
  countryCode,
  hostPlatform
}) {
  const _env = mapLocalEnvToDatadogEnv(env);
  const country = normalizeDatadogCountry(countryCode);
  return __spreadProps(__spreadValues({
    platform: hostPlatform,
    applicationId: DATADOG_INIT_CONFIG.appId,
    clientToken: DATADOG_INIT_CONFIG.publicToken,
    /* `site` refers to the Datadog site parameter of your organization */
    /* see https://docs.datadoghq.com/getting_started/site/ */
    site: DATADOG_INIT_VARIATIONS_CONFIG.site,
    service: DATADOG_INIT_VARIATIONS_CONFIG.service.main,
    subService: DATADOG_INIT_VARIATIONS_CONFIG.service.main,
    env: _env
  }, country ? {
    country
  } : void 0), {
    /* Specify a version number to identify the deployed version of your application in Datadog */
    version: appVersion,
    sessionSampleRate: DATADOG_INIT_VARIATIONS_CONFIG.sessionSampleRate[_env],
    sessionReplaySampleRate: DATADOG_INIT_VARIATIONS_CONFIG.sessionReplaySampleRate[_env],
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
    /* Iframe integration / Enabling session without storage */
    storeContextsAcrossPages: !isStorageDisabled,
    useSecureSessionCookie: !isStorageDisabled,
    logsSampleRate: 100,
    forwardErrorsToLogs: true,
    additionalTags: __spreadValues({}, client ? {
      client
    } : void 0)
  });
}
function initDatadog(_0) {
  return __async(this, arguments, function* ({
    appVersion,
    env,
    isStorageDisabled = false,
    isUserIdentifierEnabled = false,
    client,
    countryCode,
    hostPlatform
  }) {
    const config = getDatadogConfig({
      env,
      appVersion,
      isStorageDisabled,
      client,
      countryCode,
      hostPlatform
    });
    const {
      rum,
      logs,
      cleanup
    } = yield initDatadog$1(config);
    datadogRum = rum;
    datadogLogs = logs;
    if (isUserIdentifierEnabled) {
      datadogRum.setUser({
        id: v4()
      });
    }
    return cleanup;
  });
}
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @lightSyntaxTransform
 * @noflow
 * @nolint
 * @preventMunge
 * @preserve-invariant-messages
 */
var dist;
var hasRequiredDist;
function requireDist() {
  if (hasRequiredDist) return dist;
  hasRequiredDist = 1;
  var __create = Object.create;
  var __defProp2 = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp2 = Object.prototype.hasOwnProperty;
  var __export = (target, all) => {
    for (var name in all)
      __defProp2(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp2.call(to, key) && key !== except)
          __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !mod || !mod.__esModule ? __defProp2(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));
  var __toCommonJS = (mod) => __copyProps(__defProp2({}, "__esModule", { value: true }), mod);
  var index_exports = {};
  __export(index_exports, {
    $dispatcherGuard: () => $dispatcherGuard,
    $makeReadOnly: () => $makeReadOnly,
    $reset: () => $reset,
    $structuralCheck: () => $structuralCheck,
    c: () => c,
    clearRenderCounterRegistry: () => clearRenderCounterRegistry,
    renderCounterRegistry: () => renderCounterRegistry,
    useRenderCounter: () => useRenderCounter
  });
  dist = __toCommonJS(index_exports);
  var React2 = __toESM(React__default);
  var { useRef, useEffect, isValidElement } = React2;
  var _a2;
  var ReactSecretInternals = (
    //@ts-ignore
    (_a2 = React2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE) != null ? _a2 : React2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED
  );
  var $empty = Symbol.for("react.memo_cache_sentinel");
  var _a22;
  var c = (
    // @ts-expect-error
    typeof ((_a22 = React2.__COMPILER_RUNTIME) == null ? void 0 : _a22.c) === "function" ? (
      // @ts-expect-error
      React2.__COMPILER_RUNTIME.c
    ) : function c2(size) {
      return React2.useMemo(() => {
        const $ = new Array(size);
        for (let ii = 0; ii < size; ii++) {
          $[ii] = $empty;
        }
        $[$empty] = true;
        return $;
      }, []);
    }
  );
  var LazyGuardDispatcher = {};
  [
    "readContext",
    "useCallback",
    "useContext",
    "useEffect",
    "useImperativeHandle",
    "useInsertionEffect",
    "useLayoutEffect",
    "useMemo",
    "useReducer",
    "useRef",
    "useState",
    "useDebugValue",
    "useDeferredValue",
    "useTransition",
    "useMutableSource",
    "useSyncExternalStore",
    "useId",
    "unstable_isNewReconciler",
    "getCacheSignal",
    "getCacheForType",
    "useCacheRefresh"
  ].forEach((name) => {
    LazyGuardDispatcher[name] = () => {
      throw new Error(
        `[React] Unexpected React hook call (${name}) from a React compiled function. Check that all hooks are called directly and named according to convention ('use[A-Z]') `
      );
    };
  });
  var originalDispatcher = null;
  LazyGuardDispatcher["useMemoCache"] = (count) => {
    if (originalDispatcher == null) {
      throw new Error(
        "React Compiler internal invariant violation: unexpected null dispatcher"
      );
    } else {
      return originalDispatcher.useMemoCache(count);
    }
  };
  function setCurrent(newDispatcher) {
    ReactSecretInternals.ReactCurrentDispatcher.current = newDispatcher;
    return ReactSecretInternals.ReactCurrentDispatcher.current;
  }
  var guardFrames = [];
  function $dispatcherGuard(kind) {
    const curr = ReactSecretInternals.ReactCurrentDispatcher.current;
    if (kind === 0) {
      guardFrames.push(curr);
      if (guardFrames.length === 1) {
        originalDispatcher = curr;
      }
      if (curr === LazyGuardDispatcher) {
        throw new Error(
          `[React] Unexpected call to custom hook or component from a React compiled function. Check that (1) all hooks are called directly and named according to convention ('use[A-Z]') and (2) components are returned as JSX instead of being directly invoked.`
        );
      }
      setCurrent(LazyGuardDispatcher);
    } else if (kind === 1) {
      const lastFrame = guardFrames.pop();
      if (lastFrame == null) {
        throw new Error(
          "React Compiler internal error: unexpected null in guard stack"
        );
      }
      if (guardFrames.length === 0) {
        originalDispatcher = null;
      }
      setCurrent(lastFrame);
    } else if (kind === 2) {
      guardFrames.push(curr);
      setCurrent(originalDispatcher);
    } else if (kind === 3) {
      const lastFrame = guardFrames.pop();
      if (lastFrame == null) {
        throw new Error(
          "React Compiler internal error: unexpected null in guard stack"
        );
      }
      setCurrent(lastFrame);
    } else {
      throw new Error("React Compiler internal error: unreachable block" + kind);
    }
  }
  function $reset($) {
    for (let ii = 0; ii < $.length; ii++) {
      $[ii] = $empty;
    }
  }
  function $makeReadOnly() {
    throw new Error("TODO: implement $makeReadOnly in react-compiler-runtime");
  }
  var renderCounterRegistry = /* @__PURE__ */ new Map();
  function clearRenderCounterRegistry() {
    for (const counters of renderCounterRegistry.values()) {
      counters.forEach((counter) => {
        counter.count = 0;
      });
    }
  }
  function registerRenderCounter(name, val) {
    let counters = renderCounterRegistry.get(name);
    if (counters == null) {
      counters = /* @__PURE__ */ new Set();
      renderCounterRegistry.set(name, counters);
    }
    counters.add(val);
  }
  function removeRenderCounter(name, val) {
    const counters = renderCounterRegistry.get(name);
    if (counters == null) {
      return;
    }
    counters.delete(val);
  }
  function useRenderCounter(name) {
    const val = useRef(null);
    if (val.current != null) {
      val.current.count += 1;
    }
    useEffect(() => {
      if (val.current == null) {
        const counter = { count: 0 };
        registerRenderCounter(name, counter);
        val.current = counter;
      }
      return () => {
        if (val.current !== null) {
          removeRenderCounter(name, val.current);
        }
      };
    });
  }
  var seenErrors = /* @__PURE__ */ new Set();
  function $structuralCheck(oldValue, newValue, variableName, fnName, kind, loc) {
    function error(l, r, path, depth) {
      const str = `${fnName}:${loc} [${kind}] ${variableName}${path} changed from ${l} to ${r} at depth ${depth}`;
      if (seenErrors.has(str)) {
        return;
      }
      seenErrors.add(str);
      console.error(str);
    }
    const depthLimit = 2;
    function recur(oldValue2, newValue2, path, depth) {
      if (depth > depthLimit) {
        return;
      } else if (oldValue2 === newValue2) {
        return;
      } else if (typeof oldValue2 !== typeof newValue2) {
        error(`type ${typeof oldValue2}`, `type ${typeof newValue2}`, path, depth);
      } else if (typeof oldValue2 === "object") {
        const oldArray = Array.isArray(oldValue2);
        const newArray = Array.isArray(newValue2);
        if (oldValue2 === null && newValue2 !== null) {
          error("null", `type ${typeof newValue2}`, path, depth);
        } else if (newValue2 === null) {
          error(`type ${typeof oldValue2}`, "null", path, depth);
        } else if (oldValue2 instanceof Map) {
          if (!(newValue2 instanceof Map)) {
            error(`Map instance`, `other value`, path, depth);
          } else if (oldValue2.size !== newValue2.size) {
            error(
              `Map instance with size ${oldValue2.size}`,
              `Map instance with size ${newValue2.size}`,
              path,
              depth
            );
          } else {
            for (const [k, v] of oldValue2) {
              if (!newValue2.has(k)) {
                error(
                  `Map instance with key ${k}`,
                  `Map instance without key ${k}`,
                  path,
                  depth
                );
              } else {
                recur(v, newValue2.get(k), `${path}.get(${k})`, depth + 1);
              }
            }
          }
        } else if (newValue2 instanceof Map) {
          error("other value", `Map instance`, path, depth);
        } else if (oldValue2 instanceof Set) {
          if (!(newValue2 instanceof Set)) {
            error(`Set instance`, `other value`, path, depth);
          } else if (oldValue2.size !== newValue2.size) {
            error(
              `Set instance with size ${oldValue2.size}`,
              `Set instance with size ${newValue2.size}`,
              path,
              depth
            );
          } else {
            for (const v of newValue2) {
              if (!oldValue2.has(v)) {
                error(
                  `Set instance without element ${v}`,
                  `Set instance with element ${v}`,
                  path,
                  depth
                );
              }
            }
          }
        } else if (newValue2 instanceof Set) {
          error("other value", `Set instance`, path, depth);
        } else if (oldArray || newArray) {
          if (oldArray !== newArray) {
            error(
              `type ${oldArray ? "array" : "object"}`,
              `type ${newArray ? "array" : "object"}`,
              path,
              depth
            );
          } else if (oldValue2.length !== newValue2.length) {
            error(
              `array with length ${oldValue2.length}`,
              `array with length ${newValue2.length}`,
              path,
              depth
            );
          } else {
            for (let ii = 0; ii < oldValue2.length; ii++) {
              recur(oldValue2[ii], newValue2[ii], `${path}[${ii}]`, depth + 1);
            }
          }
        } else if (isValidElement(oldValue2) || isValidElement(newValue2)) {
          if (isValidElement(oldValue2) !== isValidElement(newValue2)) {
            error(
              `type ${isValidElement(oldValue2) ? "React element" : "object"}`,
              `type ${isValidElement(newValue2) ? "React element" : "object"}`,
              path,
              depth
            );
          } else if (oldValue2.type !== newValue2.type) {
            error(
              `React element of type ${oldValue2.type}`,
              `React element of type ${newValue2.type}`,
              path,
              depth
            );
          } else {
            recur(
              oldValue2.props,
              newValue2.props,
              `[props of ${path}]`,
              depth + 1
            );
          }
        } else {
          for (const key in newValue2) {
            if (!(key in oldValue2)) {
              error(
                `object without key ${key}`,
                `object with key ${key}`,
                path,
                depth
              );
            }
          }
          for (const key in oldValue2) {
            if (!(key in newValue2)) {
              error(
                `object with key ${key}`,
                `object without key ${key}`,
                path,
                depth
              );
            } else {
              recur(oldValue2[key], newValue2[key], `${path}.${key}`, depth + 1);
            }
          }
        }
      } else if (typeof oldValue2 === "function") {
        return;
      } else if (isNaN(oldValue2) || isNaN(newValue2)) {
        if (isNaN(oldValue2) !== isNaN(newValue2)) {
          error(
            `${isNaN(oldValue2) ? "NaN" : "non-NaN value"}`,
            `${isNaN(newValue2) ? "NaN" : "non-NaN value"}`,
            path,
            depth
          );
        }
      } else if (oldValue2 !== newValue2) {
        error(oldValue2, newValue2, path, depth);
      }
    }
    recur(oldValue, newValue, "", 0);
  }
  return dist;
}
var distExports = requireDist();
var Subscribable = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set();
    this.subscribe = this.subscribe.bind(this);
  }
  subscribe(listener) {
    this.listeners.add(listener);
    this.onSubscribe();
    return () => {
      this.listeners.delete(listener);
      this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
};
var isServer = typeof window === "undefined" || "Deno" in globalThis;
function noop() {
}
function functionalUpdate(updater, input) {
  return typeof updater === "function" ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === "number" && value >= 0 && value !== Infinity;
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function resolveStaleTime(staleTime, query) {
  return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function resolveEnabled(enabled, query) {
  return typeof enabled === "function" ? enabled(query) : enabled;
}
function matchQuery(filters, query) {
  const {
    type = "all",
    exact,
    fetchStatus,
    predicate,
    queryKey,
    stale
  } = filters;
  if (queryKey) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }
  if (type !== "all") {
    const isActive = query.isActive();
    if (type === "active" && !isActive) {
      return false;
    }
    if (type === "inactive" && isActive) {
      return false;
    }
  }
  if (typeof stale === "boolean" && query.isStale() !== stale) {
    return false;
  }
  if (fetchStatus && fetchStatus !== query.state.fetchStatus) {
    return false;
  }
  if (predicate && !predicate(query)) {
    return false;
  }
  return true;
}
function matchMutation(filters, mutation) {
  const { exact, status, predicate, mutationKey } = filters;
  if (mutationKey) {
    if (!mutation.options.mutationKey) {
      return false;
    }
    if (exact) {
      if (hashKey(mutation.options.mutationKey) !== hashKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }
  if (status && mutation.state.status !== status) {
    return false;
  }
  if (predicate && !predicate(mutation)) {
    return false;
  }
  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashKey;
  return hashFn(queryKey);
}
function hashKey(queryKey) {
  return JSON.stringify(
    queryKey,
    (_, val) => isPlainObject(val) ? Object.keys(val).sort().reduce((result, key) => {
      result[key] = val[key];
      return result;
    }, {}) : val
  );
}
function partialMatchKey(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (a && b && typeof a === "object" && typeof b === "object") {
    return Object.keys(b).every((key) => partialMatchKey(a[key], b[key]));
  }
  return false;
}
function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }
  const array = isPlainArray(a) && isPlainArray(b);
  if (array || isPlainObject(a) && isPlainObject(b)) {
    const aItems = array ? a : Object.keys(a);
    const aSize = aItems.length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? [] : {};
    let equalItems = 0;
    for (let i = 0; i < bSize; i++) {
      const key = array ? i : bItems[i];
      if ((!array && aItems.includes(key) || array) && a[key] === void 0 && b[key] === void 0) {
        copy[key] = void 0;
        equalItems++;
      } else {
        copy[key] = replaceEqualDeep(a[key], b[key]);
        if (copy[key] === a[key] && a[key] !== void 0) {
          equalItems++;
        }
      }
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
  }
  return b;
}
function shallowEqualObjects(a, b) {
  if (!b || Object.keys(a).length !== Object.keys(b).length) {
    return false;
  }
  for (const key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }
  return true;
}
function isPlainArray(value) {
  return Array.isArray(value) && value.length === Object.keys(value).length;
}
function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  }
  const ctor = o.constructor;
  if (ctor === void 0) {
    return true;
  }
  const prot = ctor.prototype;
  if (!hasObjectPrototype(prot)) {
    return false;
  }
  if (!prot.hasOwnProperty("isPrototypeOf")) {
    return false;
  }
  if (Object.getPrototypeOf(o) !== Object.prototype) {
    return false;
  }
  return true;
}
function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === "[object Object]";
}
function sleep(timeout) {
  return new Promise((resolve) => {
    setTimeout(resolve, timeout);
  });
}
function replaceData(prevData, data, options) {
  if (typeof options.structuralSharing === "function") {
    return options.structuralSharing(prevData, data);
  } else if (options.structuralSharing !== false) {
    if (process.env.NODE_ENV !== "production") {
      try {
        return replaceEqualDeep(prevData, data);
      } catch (error) {
        console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${options.queryHash}]: ${error}`
        );
        throw error;
      }
    }
    return replaceEqualDeep(prevData, data);
  }
  return data;
}
function addToEnd(items, item, max = 0) {
  const newItems = [...items, item];
  return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function addToStart(items, item, max = 0) {
  const newItems = [item, ...items];
  return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var skipToken = Symbol();
function ensureQueryFn(options, fetchOptions) {
  if (process.env.NODE_ENV !== "production") {
    if (options.queryFn === skipToken) {
      console.error(
        `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${options.queryHash}'`
      );
    }
  }
  if (!options.queryFn && (fetchOptions == null ? void 0 : fetchOptions.initialPromise)) {
    return () => fetchOptions.initialPromise;
  }
  if (!options.queryFn || options.queryFn === skipToken) {
    return () => Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
  }
  return options.queryFn;
}
function shouldThrowError(throwOnError, params) {
  if (typeof throwOnError === "function") {
    return throwOnError(...params);
  }
  return !!throwOnError;
}
var FocusManager = (_a = class extends Subscribable {
  constructor() {
    super();
    __privateAdd(this, _focused);
    __privateAdd(this, _cleanup);
    __privateAdd(this, _setup);
    __privateSet(this, _setup, (onFocus) => {
      if (!isServer && window.addEventListener) {
        const listener = () => onFocus();
        window.addEventListener("visibilitychange", listener, false);
        return () => {
          window.removeEventListener("visibilitychange", listener);
        };
      }
      return;
    });
  }
  onSubscribe() {
    if (!__privateGet(this, _cleanup)) {
      this.setEventListener(__privateGet(this, _setup));
    }
  }
  onUnsubscribe() {
    var _a2;
    if (!this.hasListeners()) {
      (_a2 = __privateGet(this, _cleanup)) == null ? void 0 : _a2.call(this);
      __privateSet(this, _cleanup, void 0);
    }
  }
  setEventListener(setup) {
    var _a2;
    __privateSet(this, _setup, setup);
    (_a2 = __privateGet(this, _cleanup)) == null ? void 0 : _a2.call(this);
    __privateSet(this, _cleanup, setup((focused) => {
      if (typeof focused === "boolean") {
        this.setFocused(focused);
      } else {
        this.onFocus();
      }
    }));
  }
  setFocused(focused) {
    const changed = __privateGet(this, _focused) !== focused;
    if (changed) {
      __privateSet(this, _focused, focused);
      this.onFocus();
    }
  }
  onFocus() {
    const isFocused = this.isFocused();
    this.listeners.forEach((listener) => {
      listener(isFocused);
    });
  }
  isFocused() {
    var _a2;
    if (typeof __privateGet(this, _focused) === "boolean") {
      return __privateGet(this, _focused);
    }
    return ((_a2 = globalThis.document) == null ? void 0 : _a2.visibilityState) !== "hidden";
  }
}, _focused = new WeakMap(), _cleanup = new WeakMap(), _setup = new WeakMap(), _a);
var focusManager = new FocusManager();
var OnlineManager = (_b = class extends Subscribable {
  constructor() {
    super();
    __privateAdd(this, _online, true);
    __privateAdd(this, _cleanup2);
    __privateAdd(this, _setup2);
    __privateSet(this, _setup2, (onOnline) => {
      if (!isServer && window.addEventListener) {
        const onlineListener = () => onOnline(true);
        const offlineListener = () => onOnline(false);
        window.addEventListener("online", onlineListener, false);
        window.addEventListener("offline", offlineListener, false);
        return () => {
          window.removeEventListener("online", onlineListener);
          window.removeEventListener("offline", offlineListener);
        };
      }
      return;
    });
  }
  onSubscribe() {
    if (!__privateGet(this, _cleanup2)) {
      this.setEventListener(__privateGet(this, _setup2));
    }
  }
  onUnsubscribe() {
    var _a2;
    if (!this.hasListeners()) {
      (_a2 = __privateGet(this, _cleanup2)) == null ? void 0 : _a2.call(this);
      __privateSet(this, _cleanup2, void 0);
    }
  }
  setEventListener(setup) {
    var _a2;
    __privateSet(this, _setup2, setup);
    (_a2 = __privateGet(this, _cleanup2)) == null ? void 0 : _a2.call(this);
    __privateSet(this, _cleanup2, setup(this.setOnline.bind(this)));
  }
  setOnline(online) {
    const changed = __privateGet(this, _online) !== online;
    if (changed) {
      __privateSet(this, _online, online);
      this.listeners.forEach((listener) => {
        listener(online);
      });
    }
  }
  isOnline() {
    return __privateGet(this, _online);
  }
}, _online = new WeakMap(), _cleanup2 = new WeakMap(), _setup2 = new WeakMap(), _b);
var onlineManager = new OnlineManager();
function pendingThenable() {
  let resolve;
  let reject;
  const thenable = new Promise((_resolve, _reject) => {
    resolve = _resolve;
    reject = _reject;
  });
  thenable.status = "pending";
  thenable.catch(() => {
  });
  function finalize(data) {
    Object.assign(thenable, data);
    delete thenable.resolve;
    delete thenable.reject;
  }
  thenable.resolve = (value) => {
    finalize({
      status: "fulfilled",
      value
    });
    resolve(value);
  };
  thenable.reject = (reason) => {
    finalize({
      status: "rejected",
      reason
    });
    reject(reason);
  };
  return thenable;
}
function defaultRetryDelay(failureCount) {
  return Math.min(1e3 * __pow(2, failureCount), 3e4);
}
function canFetch(networkMode) {
  return (networkMode != null ? networkMode : "online") === "online" ? onlineManager.isOnline() : true;
}
var CancelledError = class extends Error {
  constructor(options) {
    super("CancelledError");
    this.revert = options == null ? void 0 : options.revert;
    this.silent = options == null ? void 0 : options.silent;
  }
};
function isCancelledError(value) {
  return value instanceof CancelledError;
}
function createRetryer(config) {
  let isRetryCancelled = false;
  let failureCount = 0;
  let isResolved = false;
  let continueFn;
  const thenable = pendingThenable();
  const cancel = (cancelOptions) => {
    var _a2;
    if (!isResolved) {
      reject(new CancelledError(cancelOptions));
      (_a2 = config.abort) == null ? void 0 : _a2.call(config);
    }
  };
  const cancelRetry = () => {
    isRetryCancelled = true;
  };
  const continueRetry = () => {
    isRetryCancelled = false;
  };
  const canContinue = () => focusManager.isFocused() && (config.networkMode === "always" || onlineManager.isOnline()) && config.canRun();
  const canStart = () => canFetch(config.networkMode) && config.canRun();
  const resolve = (value) => {
    var _a2;
    if (!isResolved) {
      isResolved = true;
      (_a2 = config.onSuccess) == null ? void 0 : _a2.call(config, value);
      continueFn == null ? void 0 : continueFn();
      thenable.resolve(value);
    }
  };
  const reject = (value) => {
    var _a2;
    if (!isResolved) {
      isResolved = true;
      (_a2 = config.onError) == null ? void 0 : _a2.call(config, value);
      continueFn == null ? void 0 : continueFn();
      thenable.reject(value);
    }
  };
  const pause = () => {
    return new Promise((continueResolve) => {
      var _a2;
      continueFn = (value) => {
        if (isResolved || canContinue()) {
          continueResolve(value);
        }
      };
      (_a2 = config.onPause) == null ? void 0 : _a2.call(config);
    }).then(() => {
      var _a2;
      continueFn = void 0;
      if (!isResolved) {
        (_a2 = config.onContinue) == null ? void 0 : _a2.call(config);
      }
    });
  };
  const run = () => {
    if (isResolved) {
      return;
    }
    let promiseOrValue;
    const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
    try {
      promiseOrValue = initialPromise != null ? initialPromise : config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    }
    Promise.resolve(promiseOrValue).then(resolve).catch((error) => {
      var _a2, _b2, _c2;
      if (isResolved) {
        return;
      }
      const retry = (_a2 = config.retry) != null ? _a2 : isServer ? 0 : 3;
      const retryDelay = (_b2 = config.retryDelay) != null ? _b2 : defaultRetryDelay;
      const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
      const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
      if (isRetryCancelled || !shouldRetry) {
        reject(error);
        return;
      }
      failureCount++;
      (_c2 = config.onFail) == null ? void 0 : _c2.call(config, failureCount, error);
      sleep(delay).then(() => {
        return canContinue() ? void 0 : pause();
      }).then(() => {
        if (isRetryCancelled) {
          reject(error);
        } else {
          run();
        }
      });
    });
  };
  return {
    promise: thenable,
    cancel,
    continue: () => {
      continueFn == null ? void 0 : continueFn();
      return thenable;
    },
    cancelRetry,
    continueRetry,
    canStart,
    start: () => {
      if (canStart()) {
        run();
      } else {
        pause().then(run);
      }
      return thenable;
    }
  };
}
var defaultScheduler = (cb) => setTimeout(cb, 0);
function createNotifyManager() {
  let queue = [];
  let transactions = 0;
  let notifyFn = (callback) => {
    callback();
  };
  let batchNotifyFn = (callback) => {
    callback();
  };
  let scheduleFn = defaultScheduler;
  const schedule = (callback) => {
    if (transactions) {
      queue.push(callback);
    } else {
      scheduleFn(() => {
        notifyFn(callback);
      });
    }
  };
  const flush = () => {
    const originalQueue = queue;
    queue = [];
    if (originalQueue.length) {
      scheduleFn(() => {
        batchNotifyFn(() => {
          originalQueue.forEach((callback) => {
            notifyFn(callback);
          });
        });
      });
    }
  };
  return {
    batch: (callback) => {
      let result;
      transactions++;
      try {
        result = callback();
      } finally {
        transactions--;
        if (!transactions) {
          flush();
        }
      }
      return result;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (callback) => {
      return (...args) => {
        schedule(() => {
          callback(...args);
        });
      };
    },
    schedule,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (fn) => {
      notifyFn = fn;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (fn) => {
      batchNotifyFn = fn;
    },
    setScheduler: (fn) => {
      scheduleFn = fn;
    }
  };
}
var notifyManager = createNotifyManager();
var Removable = (_c = class {
  constructor() {
    __privateAdd(this, _gcTimeout);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout();
    if (isValidTimeout(this.gcTime)) {
      __privateSet(this, _gcTimeout, setTimeout(() => {
        this.optionalRemove();
      }, this.gcTime));
    }
  }
  updateGcTime(newGcTime) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      newGcTime != null ? newGcTime : isServer ? Infinity : 5 * 60 * 1e3
    );
  }
  clearGcTimeout() {
    if (__privateGet(this, _gcTimeout)) {
      clearTimeout(__privateGet(this, _gcTimeout));
      __privateSet(this, _gcTimeout, void 0);
    }
  }
}, _gcTimeout = new WeakMap(), _c);
var Query = (_d = class extends Removable {
  constructor(config) {
    var _a2;
    super();
    __privateAdd(this, _Query_instances);
    __privateAdd(this, _initialState);
    __privateAdd(this, _revertState);
    __privateAdd(this, _cache);
    __privateAdd(this, _client);
    __privateAdd(this, _retryer);
    __privateAdd(this, _defaultOptions);
    __privateAdd(this, _abortSignalConsumed);
    __privateSet(this, _abortSignalConsumed, false);
    __privateSet(this, _defaultOptions, config.defaultOptions);
    this.setOptions(config.options);
    this.observers = [];
    __privateSet(this, _client, config.client);
    __privateSet(this, _cache, __privateGet(this, _client).getQueryCache());
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    __privateSet(this, _initialState, getDefaultState$1(this.options));
    this.state = (_a2 = config.state) != null ? _a2 : __privateGet(this, _initialState);
    this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    var _a2;
    return (_a2 = __privateGet(this, _retryer)) == null ? void 0 : _a2.promise;
  }
  setOptions(options) {
    this.options = __spreadValues(__spreadValues({}, __privateGet(this, _defaultOptions)), options);
    this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    if (!this.observers.length && this.state.fetchStatus === "idle") {
      __privateGet(this, _cache).remove(this);
    }
  }
  setData(newData, options) {
    const data = replaceData(this.state.data, newData, this.options);
    __privateMethod(this, _Query_instances, dispatch_fn).call(this, {
      data,
      type: "success",
      dataUpdatedAt: options == null ? void 0 : options.updatedAt,
      manual: options == null ? void 0 : options.manual
    });
    return data;
  }
  setState(state, setStateOptions) {
    __privateMethod(this, _Query_instances, dispatch_fn).call(this, { type: "setState", state, setStateOptions });
  }
  cancel(options) {
    var _a2, _b2;
    const promise = (_a2 = __privateGet(this, _retryer)) == null ? void 0 : _a2.promise;
    (_b2 = __privateGet(this, _retryer)) == null ? void 0 : _b2.cancel(options);
    return promise ? promise.then(noop).catch(noop) : Promise.resolve();
  }
  destroy() {
    super.destroy();
    this.cancel({ silent: true });
  }
  reset() {
    this.destroy();
    this.setState(__privateGet(this, _initialState));
  }
  isActive() {
    return this.observers.some(
      (observer) => resolveEnabled(observer.options.enabled, this) !== false
    );
  }
  isDisabled() {
    if (this.getObserversCount() > 0) {
      return !this.isActive();
    }
    return this.options.queryFn === skipToken || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
  }
  isStale() {
    if (this.state.isInvalidated) {
      return true;
    }
    if (this.getObserversCount() > 0) {
      return this.observers.some(
        (observer) => observer.getCurrentResult().isStale
      );
    }
    return this.state.data === void 0;
  }
  isStaleByTime(staleTime = 0) {
    return this.state.isInvalidated || this.state.data === void 0 || !timeUntilStale(this.state.dataUpdatedAt, staleTime);
  }
  onFocus() {
    var _a2;
    const observer = this.observers.find((x) => x.shouldFetchOnWindowFocus());
    observer == null ? void 0 : observer.refetch({ cancelRefetch: false });
    (_a2 = __privateGet(this, _retryer)) == null ? void 0 : _a2.continue();
  }
  onOnline() {
    var _a2;
    const observer = this.observers.find((x) => x.shouldFetchOnReconnect());
    observer == null ? void 0 : observer.refetch({ cancelRefetch: false });
    (_a2 = __privateGet(this, _retryer)) == null ? void 0 : _a2.continue();
  }
  addObserver(observer) {
    if (!this.observers.includes(observer)) {
      this.observers.push(observer);
      this.clearGcTimeout();
      __privateGet(this, _cache).notify({ type: "observerAdded", query: this, observer });
    }
  }
  removeObserver(observer) {
    if (this.observers.includes(observer)) {
      this.observers = this.observers.filter((x) => x !== observer);
      if (!this.observers.length) {
        if (__privateGet(this, _retryer)) {
          if (__privateGet(this, _abortSignalConsumed)) {
            __privateGet(this, _retryer).cancel({ revert: true });
          } else {
            __privateGet(this, _retryer).cancelRetry();
          }
        }
        this.scheduleGc();
      }
      __privateGet(this, _cache).notify({ type: "observerRemoved", query: this, observer });
    }
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    if (!this.state.isInvalidated) {
      __privateMethod(this, _Query_instances, dispatch_fn).call(this, { type: "invalidate" });
    }
  }
  fetch(options, fetchOptions) {
    var _a2, _b2, _c2;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) {
        this.cancel({ silent: true });
      } else if (__privateGet(this, _retryer)) {
        __privateGet(this, _retryer).continueRetry();
        return __privateGet(this, _retryer).promise;
      }
    }
    if (options) {
      this.setOptions(options);
    }
    if (!this.options.queryFn) {
      const observer = this.observers.find((x) => x.options.queryFn);
      if (observer) {
        this.setOptions(observer.options);
      }
    }
    if (process.env.NODE_ENV !== "production") {
      if (!Array.isArray(this.options.queryKey)) {
        console.error(
          `As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']`
        );
      }
    }
    const abortController = new AbortController();
    const addSignalProperty = (object) => {
      Object.defineProperty(object, "signal", {
        enumerable: true,
        get: () => {
          __privateSet(this, _abortSignalConsumed, true);
          return abortController.signal;
        }
      });
    };
    const fetchFn = () => {
      const queryFn = ensureQueryFn(this.options, fetchOptions);
      const queryFnContext = {
        client: __privateGet(this, _client),
        queryKey: this.queryKey,
        meta: this.meta
      };
      addSignalProperty(queryFnContext);
      __privateSet(this, _abortSignalConsumed, false);
      if (this.options.persister) {
        return this.options.persister(
          queryFn,
          queryFnContext,
          this
        );
      }
      return queryFn(queryFnContext);
    };
    const context = {
      fetchOptions,
      options: this.options,
      queryKey: this.queryKey,
      client: __privateGet(this, _client),
      state: this.state,
      fetchFn
    };
    addSignalProperty(context);
    (_a2 = this.options.behavior) == null ? void 0 : _a2.onFetch(
      context,
      this
    );
    __privateSet(this, _revertState, this.state);
    if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_b2 = context.fetchOptions) == null ? void 0 : _b2.meta)) {
      __privateMethod(this, _Query_instances, dispatch_fn).call(this, { type: "fetch", meta: (_c2 = context.fetchOptions) == null ? void 0 : _c2.meta });
    }
    const onError = (error) => {
      var _a3, _b3, _c3, _d2;
      if (!(isCancelledError(error) && error.silent)) {
        __privateMethod(this, _Query_instances, dispatch_fn).call(this, {
          type: "error",
          error
        });
      }
      if (!isCancelledError(error)) {
        (_b3 = (_a3 = __privateGet(this, _cache).config).onError) == null ? void 0 : _b3.call(
          _a3,
          error,
          this
        );
        (_d2 = (_c3 = __privateGet(this, _cache).config).onSettled) == null ? void 0 : _d2.call(
          _c3,
          this.state.data,
          error,
          this
        );
      }
      this.scheduleGc();
    };
    __privateSet(this, _retryer, createRetryer({
      initialPromise: fetchOptions == null ? void 0 : fetchOptions.initialPromise,
      fn: context.fetchFn,
      abort: abortController.abort.bind(abortController),
      onSuccess: (data) => {
        var _a3, _b3, _c3, _d2;
        if (data === void 0) {
          if (process.env.NODE_ENV !== "production") {
            console.error(
              `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
            );
          }
          onError(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        try {
          this.setData(data);
        } catch (error) {
          onError(error);
          return;
        }
        (_b3 = (_a3 = __privateGet(this, _cache).config).onSuccess) == null ? void 0 : _b3.call(_a3, data, this);
        (_d2 = (_c3 = __privateGet(this, _cache).config).onSettled) == null ? void 0 : _d2.call(
          _c3,
          data,
          this.state.error,
          this
        );
        this.scheduleGc();
      },
      onError,
      onFail: (failureCount, error) => {
        __privateMethod(this, _Query_instances, dispatch_fn).call(this, { type: "failed", failureCount, error });
      },
      onPause: () => {
        __privateMethod(this, _Query_instances, dispatch_fn).call(this, { type: "pause" });
      },
      onContinue: () => {
        __privateMethod(this, _Query_instances, dispatch_fn).call(this, { type: "continue" });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay,
      networkMode: context.options.networkMode,
      canRun: () => true
    }));
    return __privateGet(this, _retryer).start();
  }
}, _initialState = new WeakMap(), _revertState = new WeakMap(), _cache = new WeakMap(), _client = new WeakMap(), _retryer = new WeakMap(), _defaultOptions = new WeakMap(), _abortSignalConsumed = new WeakMap(), _Query_instances = new WeakSet(), dispatch_fn = function(action) {
  const reducer = (state) => {
    var _a2, _b2;
    switch (action.type) {
      case "failed":
        return __spreadProps(__spreadValues({}, state), {
          fetchFailureCount: action.failureCount,
          fetchFailureReason: action.error
        });
      case "pause":
        return __spreadProps(__spreadValues({}, state), {
          fetchStatus: "paused"
        });
      case "continue":
        return __spreadProps(__spreadValues({}, state), {
          fetchStatus: "fetching"
        });
      case "fetch":
        return __spreadProps(__spreadValues(__spreadValues({}, state), fetchState(state.data, this.options)), {
          fetchMeta: (_a2 = action.meta) != null ? _a2 : null
        });
      case "success":
        return __spreadValues(__spreadProps(__spreadValues({}, state), {
          data: action.data,
          dataUpdateCount: state.dataUpdateCount + 1,
          dataUpdatedAt: (_b2 = action.dataUpdatedAt) != null ? _b2 : Date.now(),
          error: null,
          isInvalidated: false,
          status: "success"
        }), !action.manual && {
          fetchStatus: "idle",
          fetchFailureCount: 0,
          fetchFailureReason: null
        });
      case "error":
        const error = action.error;
        if (isCancelledError(error) && error.revert && __privateGet(this, _revertState)) {
          return __spreadProps(__spreadValues({}, __privateGet(this, _revertState)), { fetchStatus: "idle" });
        }
        return __spreadProps(__spreadValues({}, state), {
          error,
          errorUpdateCount: state.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: state.fetchFailureCount + 1,
          fetchFailureReason: error,
          fetchStatus: "idle",
          status: "error"
        });
      case "invalidate":
        return __spreadProps(__spreadValues({}, state), {
          isInvalidated: true
        });
      case "setState":
        return __spreadValues(__spreadValues({}, state), action.state);
    }
  };
  this.state = reducer(this.state);
  notifyManager.batch(() => {
    this.observers.forEach((observer) => {
      observer.onQueryUpdate();
    });
    __privateGet(this, _cache).notify({ query: this, type: "updated", action });
  });
}, _d);
function fetchState(data, options) {
  return __spreadValues({
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: canFetch(options.networkMode) ? "fetching" : "paused"
  }, data === void 0 && {
    error: null,
    status: "pending"
  });
}
function getDefaultState$1(options) {
  const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
  const hasData = data !== void 0;
  const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
  return {
    data,
    dataUpdateCount: 0,
    dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: false,
    status: hasData ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var QueryCache = (_e = class extends Subscribable {
  constructor(config = {}) {
    super();
    __privateAdd(this, _queries);
    this.config = config;
    __privateSet(this, _queries, /* @__PURE__ */ new Map());
  }
  build(client, options, state) {
    var _a2;
    const queryKey = options.queryKey;
    const queryHash = (_a2 = options.queryHash) != null ? _a2 : hashQueryKeyByOptions(queryKey, options);
    let query = this.get(queryHash);
    if (!query) {
      query = new Query({
        client,
        queryKey,
        queryHash,
        options: client.defaultQueryOptions(options),
        state,
        defaultOptions: client.getQueryDefaults(queryKey)
      });
      this.add(query);
    }
    return query;
  }
  add(query) {
    if (!__privateGet(this, _queries).has(query.queryHash)) {
      __privateGet(this, _queries).set(query.queryHash, query);
      this.notify({
        type: "added",
        query
      });
    }
  }
  remove(query) {
    const queryInMap = __privateGet(this, _queries).get(query.queryHash);
    if (queryInMap) {
      query.destroy();
      if (queryInMap === query) {
        __privateGet(this, _queries).delete(query.queryHash);
      }
      this.notify({ type: "removed", query });
    }
  }
  clear() {
    notifyManager.batch(() => {
      this.getAll().forEach((query) => {
        this.remove(query);
      });
    });
  }
  get(queryHash) {
    return __privateGet(this, _queries).get(queryHash);
  }
  getAll() {
    return [...__privateGet(this, _queries).values()];
  }
  find(filters) {
    const defaultedFilters = __spreadValues({ exact: true }, filters);
    return this.getAll().find(
      (query) => matchQuery(defaultedFilters, query)
    );
  }
  findAll(filters = {}) {
    const queries = this.getAll();
    return Object.keys(filters).length > 0 ? queries.filter((query) => matchQuery(filters, query)) : queries;
  }
  notify(event) {
    notifyManager.batch(() => {
      this.listeners.forEach((listener) => {
        listener(event);
      });
    });
  }
  onFocus() {
    notifyManager.batch(() => {
      this.getAll().forEach((query) => {
        query.onFocus();
      });
    });
  }
  onOnline() {
    notifyManager.batch(() => {
      this.getAll().forEach((query) => {
        query.onOnline();
      });
    });
  }
}, _queries = new WeakMap(), _e);
var Mutation = (_f = class extends Removable {
  constructor(config) {
    super();
    __privateAdd(this, _Mutation_instances);
    __privateAdd(this, _observers);
    __privateAdd(this, _mutationCache);
    __privateAdd(this, _retryer2);
    this.mutationId = config.mutationId;
    __privateSet(this, _mutationCache, config.mutationCache);
    __privateSet(this, _observers, []);
    this.state = config.state || getDefaultState();
    this.setOptions(config.options);
    this.scheduleGc();
  }
  setOptions(options) {
    this.options = options;
    this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(observer) {
    if (!__privateGet(this, _observers).includes(observer)) {
      __privateGet(this, _observers).push(observer);
      this.clearGcTimeout();
      __privateGet(this, _mutationCache).notify({
        type: "observerAdded",
        mutation: this,
        observer
      });
    }
  }
  removeObserver(observer) {
    __privateSet(this, _observers, __privateGet(this, _observers).filter((x) => x !== observer));
    this.scheduleGc();
    __privateGet(this, _mutationCache).notify({
      type: "observerRemoved",
      mutation: this,
      observer
    });
  }
  optionalRemove() {
    if (!__privateGet(this, _observers).length) {
      if (this.state.status === "pending") {
        this.scheduleGc();
      } else {
        __privateGet(this, _mutationCache).remove(this);
      }
    }
  }
  continue() {
    var _a2, _b2;
    return (_b2 = (_a2 = __privateGet(this, _retryer2)) == null ? void 0 : _a2.continue()) != null ? _b2 : (
      // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
      this.execute(this.state.variables)
    );
  }
  execute(variables) {
    return __async(this, null, function* () {
      var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i, _j2, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u;
      const onContinue = () => {
        __privateMethod(this, _Mutation_instances, dispatch_fn2).call(this, { type: "continue" });
      };
      __privateSet(this, _retryer2, createRetryer({
        fn: () => {
          if (!this.options.mutationFn) {
            return Promise.reject(new Error("No mutationFn found"));
          }
          return this.options.mutationFn(variables);
        },
        onFail: (failureCount, error) => {
          __privateMethod(this, _Mutation_instances, dispatch_fn2).call(this, { type: "failed", failureCount, error });
        },
        onPause: () => {
          __privateMethod(this, _Mutation_instances, dispatch_fn2).call(this, { type: "pause" });
        },
        onContinue,
        retry: (_a2 = this.options.retry) != null ? _a2 : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode,
        canRun: () => __privateGet(this, _mutationCache).canRun(this)
      }));
      const restored = this.state.status === "pending";
      const isPaused = !__privateGet(this, _retryer2).canStart();
      try {
        if (restored) {
          onContinue();
        } else {
          __privateMethod(this, _Mutation_instances, dispatch_fn2).call(this, { type: "pending", variables, isPaused });
          yield (_c2 = (_b2 = __privateGet(this, _mutationCache).config).onMutate) == null ? void 0 : _c2.call(
            _b2,
            variables,
            this
          );
          const context = yield (_e2 = (_d2 = this.options).onMutate) == null ? void 0 : _e2.call(_d2, variables);
          if (context !== this.state.context) {
            __privateMethod(this, _Mutation_instances, dispatch_fn2).call(this, {
              type: "pending",
              context,
              variables,
              isPaused
            });
          }
        }
        const data = yield __privateGet(this, _retryer2).start();
        yield (_g2 = (_f2 = __privateGet(this, _mutationCache).config).onSuccess) == null ? void 0 : _g2.call(
          _f2,
          data,
          variables,
          this.state.context,
          this
        );
        yield (_i = (_h2 = this.options).onSuccess) == null ? void 0 : _i.call(_h2, data, variables, this.state.context);
        yield (_k = (_j2 = __privateGet(this, _mutationCache).config).onSettled) == null ? void 0 : _k.call(
          _j2,
          data,
          null,
          this.state.variables,
          this.state.context,
          this
        );
        yield (_m = (_l = this.options).onSettled) == null ? void 0 : _m.call(_l, data, null, variables, this.state.context);
        __privateMethod(this, _Mutation_instances, dispatch_fn2).call(this, { type: "success", data });
        return data;
      } catch (error) {
        try {
          yield (_o = (_n = __privateGet(this, _mutationCache).config).onError) == null ? void 0 : _o.call(
            _n,
            error,
            variables,
            this.state.context,
            this
          );
          yield (_q = (_p = this.options).onError) == null ? void 0 : _q.call(
            _p,
            error,
            variables,
            this.state.context
          );
          yield (_s = (_r = __privateGet(this, _mutationCache).config).onSettled) == null ? void 0 : _s.call(
            _r,
            void 0,
            error,
            this.state.variables,
            this.state.context,
            this
          );
          yield (_u = (_t = this.options).onSettled) == null ? void 0 : _u.call(
            _t,
            void 0,
            error,
            variables,
            this.state.context
          );
          throw error;
        } finally {
          __privateMethod(this, _Mutation_instances, dispatch_fn2).call(this, { type: "error", error });
        }
      } finally {
        __privateGet(this, _mutationCache).runNext(this);
      }
    });
  }
}, _observers = new WeakMap(), _mutationCache = new WeakMap(), _retryer2 = new WeakMap(), _Mutation_instances = new WeakSet(), dispatch_fn2 = function(action) {
  const reducer = (state) => {
    switch (action.type) {
      case "failed":
        return __spreadProps(__spreadValues({}, state), {
          failureCount: action.failureCount,
          failureReason: action.error
        });
      case "pause":
        return __spreadProps(__spreadValues({}, state), {
          isPaused: true
        });
      case "continue":
        return __spreadProps(__spreadValues({}, state), {
          isPaused: false
        });
      case "pending":
        return __spreadProps(__spreadValues({}, state), {
          context: action.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: action.isPaused,
          status: "pending",
          variables: action.variables,
          submittedAt: Date.now()
        });
      case "success":
        return __spreadProps(__spreadValues({}, state), {
          data: action.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: false
        });
      case "error":
        return __spreadProps(__spreadValues({}, state), {
          data: void 0,
          error: action.error,
          failureCount: state.failureCount + 1,
          failureReason: action.error,
          isPaused: false,
          status: "error"
        });
    }
  };
  this.state = reducer(this.state);
  notifyManager.batch(() => {
    __privateGet(this, _observers).forEach((observer) => {
      observer.onMutationUpdate(action);
    });
    __privateGet(this, _mutationCache).notify({
      mutation: this,
      type: "updated",
      action
    });
  });
}, _f);
function getDefaultState() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: false,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var MutationCache = (_g = class extends Subscribable {
  constructor(config = {}) {
    super();
    __privateAdd(this, _mutations);
    __privateAdd(this, _scopes);
    __privateAdd(this, _mutationId);
    this.config = config;
    __privateSet(this, _mutations, /* @__PURE__ */ new Set());
    __privateSet(this, _scopes, /* @__PURE__ */ new Map());
    __privateSet(this, _mutationId, 0);
  }
  build(client, options, state) {
    const mutation = new Mutation({
      mutationCache: this,
      mutationId: ++__privateWrapper(this, _mutationId)._,
      options: client.defaultMutationOptions(options),
      state
    });
    this.add(mutation);
    return mutation;
  }
  add(mutation) {
    __privateGet(this, _mutations).add(mutation);
    const scope = scopeFor(mutation);
    if (typeof scope === "string") {
      const scopedMutations = __privateGet(this, _scopes).get(scope);
      if (scopedMutations) {
        scopedMutations.push(mutation);
      } else {
        __privateGet(this, _scopes).set(scope, [mutation]);
      }
    }
    this.notify({ type: "added", mutation });
  }
  remove(mutation) {
    if (__privateGet(this, _mutations).delete(mutation)) {
      const scope = scopeFor(mutation);
      if (typeof scope === "string") {
        const scopedMutations = __privateGet(this, _scopes).get(scope);
        if (scopedMutations) {
          if (scopedMutations.length > 1) {
            const index = scopedMutations.indexOf(mutation);
            if (index !== -1) {
              scopedMutations.splice(index, 1);
            }
          } else if (scopedMutations[0] === mutation) {
            __privateGet(this, _scopes).delete(scope);
          }
        }
      }
    }
    this.notify({ type: "removed", mutation });
  }
  canRun(mutation) {
    const scope = scopeFor(mutation);
    if (typeof scope === "string") {
      const mutationsWithSameScope = __privateGet(this, _scopes).get(scope);
      const firstPendingMutation = mutationsWithSameScope == null ? void 0 : mutationsWithSameScope.find(
        (m) => m.state.status === "pending"
      );
      return !firstPendingMutation || firstPendingMutation === mutation;
    } else {
      return true;
    }
  }
  runNext(mutation) {
    var _a2, _b2;
    const scope = scopeFor(mutation);
    if (typeof scope === "string") {
      const foundMutation = (_a2 = __privateGet(this, _scopes).get(scope)) == null ? void 0 : _a2.find((m) => m !== mutation && m.state.isPaused);
      return (_b2 = foundMutation == null ? void 0 : foundMutation.continue()) != null ? _b2 : Promise.resolve();
    } else {
      return Promise.resolve();
    }
  }
  clear() {
    notifyManager.batch(() => {
      __privateGet(this, _mutations).forEach((mutation) => {
        this.notify({ type: "removed", mutation });
      });
      __privateGet(this, _mutations).clear();
      __privateGet(this, _scopes).clear();
    });
  }
  getAll() {
    return Array.from(__privateGet(this, _mutations));
  }
  find(filters) {
    const defaultedFilters = __spreadValues({ exact: true }, filters);
    return this.getAll().find(
      (mutation) => matchMutation(defaultedFilters, mutation)
    );
  }
  findAll(filters = {}) {
    return this.getAll().filter((mutation) => matchMutation(filters, mutation));
  }
  notify(event) {
    notifyManager.batch(() => {
      this.listeners.forEach((listener) => {
        listener(event);
      });
    });
  }
  resumePausedMutations() {
    const pausedMutations = this.getAll().filter((x) => x.state.isPaused);
    return notifyManager.batch(
      () => Promise.all(
        pausedMutations.map((mutation) => mutation.continue().catch(noop))
      )
    );
  }
}, _mutations = new WeakMap(), _scopes = new WeakMap(), _mutationId = new WeakMap(), _g);
function scopeFor(mutation) {
  var _a2;
  return (_a2 = mutation.options.scope) == null ? void 0 : _a2.id;
}
function infiniteQueryBehavior(pages) {
  return {
    onFetch: (context, query) => {
      var _a2, _b2, _c2, _d2, _e2;
      const options = context.options;
      const direction = (_c2 = (_b2 = (_a2 = context.fetchOptions) == null ? void 0 : _a2.meta) == null ? void 0 : _b2.fetchMore) == null ? void 0 : _c2.direction;
      const oldPages = ((_d2 = context.state.data) == null ? void 0 : _d2.pages) || [];
      const oldPageParams = ((_e2 = context.state.data) == null ? void 0 : _e2.pageParams) || [];
      let result = { pages: [], pageParams: [] };
      let currentPage = 0;
      const fetchFn = () => __async(null, null, function* () {
        var _a3;
        let cancelled = false;
        const addSignalProperty = (object) => {
          Object.defineProperty(object, "signal", {
            enumerable: true,
            get: () => {
              if (context.signal.aborted) {
                cancelled = true;
              } else {
                context.signal.addEventListener("abort", () => {
                  cancelled = true;
                });
              }
              return context.signal;
            }
          });
        };
        const queryFn = ensureQueryFn(context.options, context.fetchOptions);
        const fetchPage = (data, param, previous) => __async(null, null, function* () {
          if (cancelled) {
            return Promise.reject();
          }
          if (param == null && data.pages.length) {
            return Promise.resolve(data);
          }
          const queryFnContext = {
            client: context.client,
            queryKey: context.queryKey,
            pageParam: param,
            direction: previous ? "backward" : "forward",
            meta: context.options.meta
          };
          addSignalProperty(queryFnContext);
          const page = yield queryFn(
            queryFnContext
          );
          const { maxPages } = context.options;
          const addTo = previous ? addToStart : addToEnd;
          return {
            pages: addTo(data.pages, page, maxPages),
            pageParams: addTo(data.pageParams, param, maxPages)
          };
        });
        if (direction && oldPages.length) {
          const previous = direction === "backward";
          const pageParamFn = previous ? getPreviousPageParam : getNextPageParam;
          const oldData = {
            pages: oldPages,
            pageParams: oldPageParams
          };
          const param = pageParamFn(options, oldData);
          result = yield fetchPage(oldData, param, previous);
        } else {
          const remainingPages = pages != null ? pages : oldPages.length;
          do {
            const param = currentPage === 0 ? (_a3 = oldPageParams[0]) != null ? _a3 : options.initialPageParam : getNextPageParam(options, result);
            if (currentPage > 0 && param == null) {
              break;
            }
            result = yield fetchPage(result, param);
            currentPage++;
          } while (currentPage < remainingPages);
        }
        return result;
      });
      if (context.options.persister) {
        context.fetchFn = () => {
          var _a3, _b3;
          return (_b3 = (_a3 = context.options).persister) == null ? void 0 : _b3.call(
            _a3,
            fetchFn,
            {
              client: context.client,
              queryKey: context.queryKey,
              meta: context.options.meta,
              signal: context.signal
            },
            query
          );
        };
      } else {
        context.fetchFn = fetchFn;
      }
    }
  };
}
function getNextPageParam(options, { pages, pageParams }) {
  const lastIndex = pages.length - 1;
  return pages.length > 0 ? options.getNextPageParam(
    pages[lastIndex],
    pages,
    pageParams[lastIndex],
    pageParams
  ) : void 0;
}
function getPreviousPageParam(options, { pages, pageParams }) {
  var _a2;
  return pages.length > 0 ? (_a2 = options.getPreviousPageParam) == null ? void 0 : _a2.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
function hasNextPage(options, data) {
  if (!data) return false;
  return getNextPageParam(options, data) != null;
}
function hasPreviousPage(options, data) {
  if (!data || !options.getPreviousPageParam) return false;
  return getPreviousPageParam(options, data) != null;
}
var QueryClient = (_h = class {
  constructor(config = {}) {
    __privateAdd(this, _queryCache);
    __privateAdd(this, _mutationCache2);
    __privateAdd(this, _defaultOptions2);
    __privateAdd(this, _queryDefaults);
    __privateAdd(this, _mutationDefaults);
    __privateAdd(this, _mountCount);
    __privateAdd(this, _unsubscribeFocus);
    __privateAdd(this, _unsubscribeOnline);
    __privateSet(this, _queryCache, config.queryCache || new QueryCache());
    __privateSet(this, _mutationCache2, config.mutationCache || new MutationCache());
    __privateSet(this, _defaultOptions2, config.defaultOptions || {});
    __privateSet(this, _queryDefaults, /* @__PURE__ */ new Map());
    __privateSet(this, _mutationDefaults, /* @__PURE__ */ new Map());
    __privateSet(this, _mountCount, 0);
  }
  mount() {
    __privateWrapper(this, _mountCount)._++;
    if (__privateGet(this, _mountCount) !== 1) return;
    __privateSet(this, _unsubscribeFocus, focusManager.subscribe((focused) => __async(this, null, function* () {
      if (focused) {
        yield this.resumePausedMutations();
        __privateGet(this, _queryCache).onFocus();
      }
    })));
    __privateSet(this, _unsubscribeOnline, onlineManager.subscribe((online) => __async(this, null, function* () {
      if (online) {
        yield this.resumePausedMutations();
        __privateGet(this, _queryCache).onOnline();
      }
    })));
  }
  unmount() {
    var _a2, _b2;
    __privateWrapper(this, _mountCount)._--;
    if (__privateGet(this, _mountCount) !== 0) return;
    (_a2 = __privateGet(this, _unsubscribeFocus)) == null ? void 0 : _a2.call(this);
    __privateSet(this, _unsubscribeFocus, void 0);
    (_b2 = __privateGet(this, _unsubscribeOnline)) == null ? void 0 : _b2.call(this);
    __privateSet(this, _unsubscribeOnline, void 0);
  }
  isFetching(filters) {
    return __privateGet(this, _queryCache).findAll(__spreadProps(__spreadValues({}, filters), { fetchStatus: "fetching" })).length;
  }
  isMutating(filters) {
    return __privateGet(this, _mutationCache2).findAll(__spreadProps(__spreadValues({}, filters), { status: "pending" })).length;
  }
  /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */
  getQueryData(queryKey) {
    var _a2;
    const options = this.defaultQueryOptions({ queryKey });
    return (_a2 = __privateGet(this, _queryCache).get(options.queryHash)) == null ? void 0 : _a2.state.data;
  }
  ensureQueryData(options) {
    const defaultedOptions = this.defaultQueryOptions(options);
    const query = __privateGet(this, _queryCache).build(this, defaultedOptions);
    const cachedData = query.state.data;
    if (cachedData === void 0) {
      return this.fetchQuery(options);
    }
    if (options.revalidateIfStale && query.isStaleByTime(resolveStaleTime(defaultedOptions.staleTime, query))) {
      void this.prefetchQuery(defaultedOptions);
    }
    return Promise.resolve(cachedData);
  }
  getQueriesData(filters) {
    return __privateGet(this, _queryCache).findAll(filters).map(({ queryKey, state }) => {
      const data = state.data;
      return [queryKey, data];
    });
  }
  setQueryData(queryKey, updater, options) {
    const defaultedOptions = this.defaultQueryOptions({ queryKey });
    const query = __privateGet(this, _queryCache).get(
      defaultedOptions.queryHash
    );
    const prevData = query == null ? void 0 : query.state.data;
    const data = functionalUpdate(updater, prevData);
    if (data === void 0) {
      return void 0;
    }
    return __privateGet(this, _queryCache).build(this, defaultedOptions).setData(data, __spreadProps(__spreadValues({}, options), { manual: true }));
  }
  setQueriesData(filters, updater, options) {
    return notifyManager.batch(
      () => __privateGet(this, _queryCache).findAll(filters).map(({ queryKey }) => [
        queryKey,
        this.setQueryData(queryKey, updater, options)
      ])
    );
  }
  getQueryState(queryKey) {
    var _a2;
    const options = this.defaultQueryOptions({ queryKey });
    return (_a2 = __privateGet(this, _queryCache).get(
      options.queryHash
    )) == null ? void 0 : _a2.state;
  }
  removeQueries(filters) {
    const queryCache = __privateGet(this, _queryCache);
    notifyManager.batch(() => {
      queryCache.findAll(filters).forEach((query) => {
        queryCache.remove(query);
      });
    });
  }
  resetQueries(filters, options) {
    const queryCache = __privateGet(this, _queryCache);
    return notifyManager.batch(() => {
      queryCache.findAll(filters).forEach((query) => {
        query.reset();
      });
      return this.refetchQueries(
        __spreadValues({
          type: "active"
        }, filters),
        options
      );
    });
  }
  cancelQueries(filters, cancelOptions = {}) {
    const defaultedCancelOptions = __spreadValues({ revert: true }, cancelOptions);
    const promises = notifyManager.batch(
      () => __privateGet(this, _queryCache).findAll(filters).map((query) => query.cancel(defaultedCancelOptions))
    );
    return Promise.all(promises).then(noop).catch(noop);
  }
  invalidateQueries(filters, options = {}) {
    return notifyManager.batch(() => {
      var _a2, _b2;
      __privateGet(this, _queryCache).findAll(filters).forEach((query) => {
        query.invalidate();
      });
      if ((filters == null ? void 0 : filters.refetchType) === "none") {
        return Promise.resolve();
      }
      return this.refetchQueries(
        __spreadProps(__spreadValues({}, filters), {
          type: (_b2 = (_a2 = filters == null ? void 0 : filters.refetchType) != null ? _a2 : filters == null ? void 0 : filters.type) != null ? _b2 : "active"
        }),
        options
      );
    });
  }
  refetchQueries(filters, options = {}) {
    var _a2;
    const fetchOptions = __spreadProps(__spreadValues({}, options), {
      cancelRefetch: (_a2 = options.cancelRefetch) != null ? _a2 : true
    });
    const promises = notifyManager.batch(
      () => __privateGet(this, _queryCache).findAll(filters).filter((query) => !query.isDisabled()).map((query) => {
        let promise = query.fetch(void 0, fetchOptions);
        if (!fetchOptions.throwOnError) {
          promise = promise.catch(noop);
        }
        return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
      })
    );
    return Promise.all(promises).then(noop);
  }
  fetchQuery(options) {
    const defaultedOptions = this.defaultQueryOptions(options);
    if (defaultedOptions.retry === void 0) {
      defaultedOptions.retry = false;
    }
    const query = __privateGet(this, _queryCache).build(this, defaultedOptions);
    return query.isStaleByTime(
      resolveStaleTime(defaultedOptions.staleTime, query)
    ) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  }
  prefetchQuery(options) {
    return this.fetchQuery(options).then(noop).catch(noop);
  }
  fetchInfiniteQuery(options) {
    options.behavior = infiniteQueryBehavior(options.pages);
    return this.fetchQuery(options);
  }
  prefetchInfiniteQuery(options) {
    return this.fetchInfiniteQuery(options).then(noop).catch(noop);
  }
  ensureInfiniteQueryData(options) {
    options.behavior = infiniteQueryBehavior(options.pages);
    return this.ensureQueryData(options);
  }
  resumePausedMutations() {
    if (onlineManager.isOnline()) {
      return __privateGet(this, _mutationCache2).resumePausedMutations();
    }
    return Promise.resolve();
  }
  getQueryCache() {
    return __privateGet(this, _queryCache);
  }
  getMutationCache() {
    return __privateGet(this, _mutationCache2);
  }
  getDefaultOptions() {
    return __privateGet(this, _defaultOptions2);
  }
  setDefaultOptions(options) {
    __privateSet(this, _defaultOptions2, options);
  }
  setQueryDefaults(queryKey, options) {
    __privateGet(this, _queryDefaults).set(hashKey(queryKey), {
      queryKey,
      defaultOptions: options
    });
  }
  getQueryDefaults(queryKey) {
    const defaults = [...__privateGet(this, _queryDefaults).values()];
    const result = {};
    defaults.forEach((queryDefault) => {
      if (partialMatchKey(queryKey, queryDefault.queryKey)) {
        Object.assign(result, queryDefault.defaultOptions);
      }
    });
    return result;
  }
  setMutationDefaults(mutationKey, options) {
    __privateGet(this, _mutationDefaults).set(hashKey(mutationKey), {
      mutationKey,
      defaultOptions: options
    });
  }
  getMutationDefaults(mutationKey) {
    const defaults = [...__privateGet(this, _mutationDefaults).values()];
    const result = {};
    defaults.forEach((queryDefault) => {
      if (partialMatchKey(mutationKey, queryDefault.mutationKey)) {
        Object.assign(result, queryDefault.defaultOptions);
      }
    });
    return result;
  }
  defaultQueryOptions(options) {
    if (options._defaulted) {
      return options;
    }
    const defaultedOptions = __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, __privateGet(this, _defaultOptions2).queries), this.getQueryDefaults(options.queryKey)), options), {
      _defaulted: true
    });
    if (!defaultedOptions.queryHash) {
      defaultedOptions.queryHash = hashQueryKeyByOptions(
        defaultedOptions.queryKey,
        defaultedOptions
      );
    }
    if (defaultedOptions.refetchOnReconnect === void 0) {
      defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
    }
    if (defaultedOptions.throwOnError === void 0) {
      defaultedOptions.throwOnError = !!defaultedOptions.suspense;
    }
    if (!defaultedOptions.networkMode && defaultedOptions.persister) {
      defaultedOptions.networkMode = "offlineFirst";
    }
    if (defaultedOptions.queryFn === skipToken) {
      defaultedOptions.enabled = false;
    }
    return defaultedOptions;
  }
  defaultMutationOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }
    return __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, __privateGet(this, _defaultOptions2).mutations), (options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey)), options), {
      _defaulted: true
    });
  }
  clear() {
    __privateGet(this, _queryCache).clear();
    __privateGet(this, _mutationCache2).clear();
  }
}, _queryCache = new WeakMap(), _mutationCache2 = new WeakMap(), _defaultOptions2 = new WeakMap(), _queryDefaults = new WeakMap(), _mutationDefaults = new WeakMap(), _mountCount = new WeakMap(), _unsubscribeFocus = new WeakMap(), _unsubscribeOnline = new WeakMap(), _h);
var QueryObserver = (_j = class extends Subscribable {
  constructor(client, options) {
    super();
    __privateAdd(this, _QueryObserver_instances);
    __privateAdd(this, _client2);
    __privateAdd(this, _currentQuery);
    __privateAdd(this, _currentQueryInitialState);
    __privateAdd(this, _currentResult);
    __privateAdd(this, _currentResultState);
    __privateAdd(this, _currentResultOptions);
    __privateAdd(this, _currentThenable);
    __privateAdd(this, _selectError);
    __privateAdd(this, _selectFn);
    __privateAdd(this, _selectResult);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    __privateAdd(this, _lastQueryWithDefinedData);
    __privateAdd(this, _staleTimeoutId);
    __privateAdd(this, _refetchIntervalId);
    __privateAdd(this, _currentRefetchInterval);
    __privateAdd(this, _trackedProps, /* @__PURE__ */ new Set());
    this.options = options;
    __privateSet(this, _client2, client);
    __privateSet(this, _selectError, null);
    __privateSet(this, _currentThenable, pendingThenable());
    if (!this.options.experimental_prefetchInRender) {
      __privateGet(this, _currentThenable).reject(
        new Error("experimental_prefetchInRender feature flag is not enabled")
      );
    }
    this.bindMethods();
    this.setOptions(options);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    if (this.listeners.size === 1) {
      __privateGet(this, _currentQuery).addObserver(this);
      if (shouldFetchOnMount(__privateGet(this, _currentQuery), this.options)) {
        __privateMethod(this, _QueryObserver_instances, executeFetch_fn).call(this);
      } else {
        this.updateResult();
      }
      __privateMethod(this, _QueryObserver_instances, updateTimers_fn).call(this);
    }
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      this.destroy();
    }
  }
  shouldFetchOnReconnect() {
    return shouldFetchOn(
      __privateGet(this, _currentQuery),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return shouldFetchOn(
      __privateGet(this, _currentQuery),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set();
    __privateMethod(this, _QueryObserver_instances, clearStaleTimeout_fn).call(this);
    __privateMethod(this, _QueryObserver_instances, clearRefetchInterval_fn).call(this);
    __privateGet(this, _currentQuery).removeObserver(this);
  }
  setOptions(options) {
    const prevOptions = this.options;
    const prevQuery = __privateGet(this, _currentQuery);
    this.options = __privateGet(this, _client2).defaultQueryOptions(options);
    if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof resolveEnabled(this.options.enabled, __privateGet(this, _currentQuery)) !== "boolean") {
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    }
    __privateMethod(this, _QueryObserver_instances, updateQuery_fn).call(this);
    __privateGet(this, _currentQuery).setOptions(this.options);
    if (prevOptions._defaulted && !shallowEqualObjects(this.options, prevOptions)) {
      __privateGet(this, _client2).getQueryCache().notify({
        type: "observerOptionsUpdated",
        query: __privateGet(this, _currentQuery),
        observer: this
      });
    }
    const mounted = this.hasListeners();
    if (mounted && shouldFetchOptionally(
      __privateGet(this, _currentQuery),
      prevQuery,
      this.options,
      prevOptions
    )) {
      __privateMethod(this, _QueryObserver_instances, executeFetch_fn).call(this);
    }
    this.updateResult();
    if (mounted && (__privateGet(this, _currentQuery) !== prevQuery || resolveEnabled(this.options.enabled, __privateGet(this, _currentQuery)) !== resolveEnabled(prevOptions.enabled, __privateGet(this, _currentQuery)) || resolveStaleTime(this.options.staleTime, __privateGet(this, _currentQuery)) !== resolveStaleTime(prevOptions.staleTime, __privateGet(this, _currentQuery)))) {
      __privateMethod(this, _QueryObserver_instances, updateStaleTimeout_fn).call(this);
    }
    const nextRefetchInterval = __privateMethod(this, _QueryObserver_instances, computeRefetchInterval_fn).call(this);
    if (mounted && (__privateGet(this, _currentQuery) !== prevQuery || resolveEnabled(this.options.enabled, __privateGet(this, _currentQuery)) !== resolveEnabled(prevOptions.enabled, __privateGet(this, _currentQuery)) || nextRefetchInterval !== __privateGet(this, _currentRefetchInterval))) {
      __privateMethod(this, _QueryObserver_instances, updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
  }
  getOptimisticResult(options) {
    const query = __privateGet(this, _client2).getQueryCache().build(__privateGet(this, _client2), options);
    const result = this.createResult(query, options);
    if (shouldAssignObserverCurrentProperties(this, result)) {
      __privateSet(this, _currentResult, result);
      __privateSet(this, _currentResultOptions, this.options);
      __privateSet(this, _currentResultState, __privateGet(this, _currentQuery).state);
    }
    return result;
  }
  getCurrentResult() {
    return __privateGet(this, _currentResult);
  }
  trackResult(result, onPropTracked) {
    return new Proxy(result, {
      get: (target, key) => {
        this.trackProp(key);
        onPropTracked == null ? void 0 : onPropTracked(key);
        return Reflect.get(target, key);
      }
    });
  }
  trackProp(key) {
    __privateGet(this, _trackedProps).add(key);
  }
  getCurrentQuery() {
    return __privateGet(this, _currentQuery);
  }
  refetch(_i = {}) {
    var options = __objRest(_i, []);
    return this.fetch(__spreadValues({}, options));
  }
  fetchOptimistic(options) {
    const defaultedOptions = __privateGet(this, _client2).defaultQueryOptions(options);
    const query = __privateGet(this, _client2).getQueryCache().build(__privateGet(this, _client2), defaultedOptions);
    return query.fetch().then(() => this.createResult(query, defaultedOptions));
  }
  fetch(fetchOptions) {
    var _a2;
    return __privateMethod(this, _QueryObserver_instances, executeFetch_fn).call(this, __spreadProps(__spreadValues({}, fetchOptions), {
      cancelRefetch: (_a2 = fetchOptions.cancelRefetch) != null ? _a2 : true
    })).then(() => {
      this.updateResult();
      return __privateGet(this, _currentResult);
    });
  }
  createResult(query, options) {
    var _a2;
    const prevQuery = __privateGet(this, _currentQuery);
    const prevOptions = this.options;
    const prevResult = __privateGet(this, _currentResult);
    const prevResultState = __privateGet(this, _currentResultState);
    const prevResultOptions = __privateGet(this, _currentResultOptions);
    const queryChange = query !== prevQuery;
    const queryInitialState = queryChange ? query.state : __privateGet(this, _currentQueryInitialState);
    const { state } = query;
    let newState = __spreadValues({}, state);
    let isPlaceholderData = false;
    let data;
    if (options._optimisticResults) {
      const mounted = this.hasListeners();
      const fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      const fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);
      if (fetchOnMount || fetchOptionally) {
        newState = __spreadValues(__spreadValues({}, newState), fetchState(state.data, query.options));
      }
      if (options._optimisticResults === "isRestoring") {
        newState.fetchStatus = "idle";
      }
    }
    let { error, errorUpdatedAt, status } = newState;
    data = newState.data;
    let skipSelect = false;
    if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
      let placeholderData;
      if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
        skipSelect = true;
      } else {
        placeholderData = typeof options.placeholderData === "function" ? options.placeholderData(
          (_a2 = __privateGet(this, _lastQueryWithDefinedData)) == null ? void 0 : _a2.state.data,
          __privateGet(this, _lastQueryWithDefinedData)
        ) : options.placeholderData;
      }
      if (placeholderData !== void 0) {
        status = "success";
        data = replaceData(
          prevResult == null ? void 0 : prevResult.data,
          placeholderData,
          options
        );
        isPlaceholderData = true;
      }
    }
    if (options.select && data !== void 0 && !skipSelect) {
      if (prevResult && data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === __privateGet(this, _selectFn)) {
        data = __privateGet(this, _selectResult);
      } else {
        try {
          __privateSet(this, _selectFn, options.select);
          data = options.select(data);
          data = replaceData(prevResult == null ? void 0 : prevResult.data, data, options);
          __privateSet(this, _selectResult, data);
          __privateSet(this, _selectError, null);
        } catch (selectError) {
          __privateSet(this, _selectError, selectError);
        }
      }
    }
    if (__privateGet(this, _selectError)) {
      error = __privateGet(this, _selectError);
      data = __privateGet(this, _selectResult);
      errorUpdatedAt = Date.now();
      status = "error";
    }
    const isFetching = newState.fetchStatus === "fetching";
    const isPending = status === "pending";
    const isError = status === "error";
    const isLoading = isPending && isFetching;
    const hasData = data !== void 0;
    const result = {
      status,
      fetchStatus: newState.fetchStatus,
      isPending,
      isSuccess: status === "success",
      isError,
      isInitialLoading: isLoading,
      isLoading,
      data,
      dataUpdatedAt: newState.dataUpdatedAt,
      error,
      errorUpdatedAt,
      failureCount: newState.fetchFailureCount,
      failureReason: newState.fetchFailureReason,
      errorUpdateCount: newState.errorUpdateCount,
      isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
      isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching,
      isRefetching: isFetching && !isPending,
      isLoadingError: isError && !hasData,
      isPaused: newState.fetchStatus === "paused",
      isPlaceholderData,
      isRefetchError: isError && hasData,
      isStale: isStale(query, options),
      refetch: this.refetch,
      promise: __privateGet(this, _currentThenable)
    };
    const nextResult = result;
    if (this.options.experimental_prefetchInRender) {
      const finalizeThenableIfPossible = (thenable) => {
        if (nextResult.status === "error") {
          thenable.reject(nextResult.error);
        } else if (nextResult.data !== void 0) {
          thenable.resolve(nextResult.data);
        }
      };
      const recreateThenable = () => {
        const pending = __privateSet(this, _currentThenable, nextResult.promise = pendingThenable());
        finalizeThenableIfPossible(pending);
      };
      const prevThenable = __privateGet(this, _currentThenable);
      switch (prevThenable.status) {
        case "pending":
          if (query.queryHash === prevQuery.queryHash) {
            finalizeThenableIfPossible(prevThenable);
          }
          break;
        case "fulfilled":
          if (nextResult.status === "error" || nextResult.data !== prevThenable.value) {
            recreateThenable();
          }
          break;
        case "rejected":
          if (nextResult.status !== "error" || nextResult.error !== prevThenable.reason) {
            recreateThenable();
          }
          break;
      }
    }
    return nextResult;
  }
  updateResult() {
    const prevResult = __privateGet(this, _currentResult);
    const nextResult = this.createResult(__privateGet(this, _currentQuery), this.options);
    __privateSet(this, _currentResultState, __privateGet(this, _currentQuery).state);
    __privateSet(this, _currentResultOptions, this.options);
    if (__privateGet(this, _currentResultState).data !== void 0) {
      __privateSet(this, _lastQueryWithDefinedData, __privateGet(this, _currentQuery));
    }
    if (shallowEqualObjects(nextResult, prevResult)) {
      return;
    }
    __privateSet(this, _currentResult, nextResult);
    const shouldNotifyListeners = () => {
      if (!prevResult) {
        return true;
      }
      const { notifyOnChangeProps } = this.options;
      const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
      if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !__privateGet(this, _trackedProps).size) {
        return true;
      }
      const includedProps = new Set(
        notifyOnChangePropsValue != null ? notifyOnChangePropsValue : __privateGet(this, _trackedProps)
      );
      if (this.options.throwOnError) {
        includedProps.add("error");
      }
      return Object.keys(__privateGet(this, _currentResult)).some((key) => {
        const typedKey = key;
        const changed = __privateGet(this, _currentResult)[typedKey] !== prevResult[typedKey];
        return changed && includedProps.has(typedKey);
      });
    };
    __privateMethod(this, _QueryObserver_instances, notify_fn).call(this, { listeners: shouldNotifyListeners() });
  }
  onQueryUpdate() {
    this.updateResult();
    if (this.hasListeners()) {
      __privateMethod(this, _QueryObserver_instances, updateTimers_fn).call(this);
    }
  }
}, _client2 = new WeakMap(), _currentQuery = new WeakMap(), _currentQueryInitialState = new WeakMap(), _currentResult = new WeakMap(), _currentResultState = new WeakMap(), _currentResultOptions = new WeakMap(), _currentThenable = new WeakMap(), _selectError = new WeakMap(), _selectFn = new WeakMap(), _selectResult = new WeakMap(), _lastQueryWithDefinedData = new WeakMap(), _staleTimeoutId = new WeakMap(), _refetchIntervalId = new WeakMap(), _currentRefetchInterval = new WeakMap(), _trackedProps = new WeakMap(), _QueryObserver_instances = new WeakSet(), executeFetch_fn = function(fetchOptions) {
  __privateMethod(this, _QueryObserver_instances, updateQuery_fn).call(this);
  let promise = __privateGet(this, _currentQuery).fetch(
    this.options,
    fetchOptions
  );
  if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) {
    promise = promise.catch(noop);
  }
  return promise;
}, updateStaleTimeout_fn = function() {
  __privateMethod(this, _QueryObserver_instances, clearStaleTimeout_fn).call(this);
  const staleTime = resolveStaleTime(
    this.options.staleTime,
    __privateGet(this, _currentQuery)
  );
  if (isServer || __privateGet(this, _currentResult).isStale || !isValidTimeout(staleTime)) {
    return;
  }
  const time = timeUntilStale(__privateGet(this, _currentResult).dataUpdatedAt, staleTime);
  const timeout = time + 1;
  __privateSet(this, _staleTimeoutId, setTimeout(() => {
    if (!__privateGet(this, _currentResult).isStale) {
      this.updateResult();
    }
  }, timeout));
}, computeRefetchInterval_fn = function() {
  var _a2;
  return (_a2 = typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(__privateGet(this, _currentQuery)) : this.options.refetchInterval) != null ? _a2 : false;
}, updateRefetchInterval_fn = function(nextInterval) {
  __privateMethod(this, _QueryObserver_instances, clearRefetchInterval_fn).call(this);
  __privateSet(this, _currentRefetchInterval, nextInterval);
  if (isServer || resolveEnabled(this.options.enabled, __privateGet(this, _currentQuery)) === false || !isValidTimeout(__privateGet(this, _currentRefetchInterval)) || __privateGet(this, _currentRefetchInterval) === 0) {
    return;
  }
  __privateSet(this, _refetchIntervalId, setInterval(() => {
    if (this.options.refetchIntervalInBackground || focusManager.isFocused()) {
      __privateMethod(this, _QueryObserver_instances, executeFetch_fn).call(this);
    }
  }, __privateGet(this, _currentRefetchInterval)));
}, updateTimers_fn = function() {
  __privateMethod(this, _QueryObserver_instances, updateStaleTimeout_fn).call(this);
  __privateMethod(this, _QueryObserver_instances, updateRefetchInterval_fn).call(this, __privateMethod(this, _QueryObserver_instances, computeRefetchInterval_fn).call(this));
}, clearStaleTimeout_fn = function() {
  if (__privateGet(this, _staleTimeoutId)) {
    clearTimeout(__privateGet(this, _staleTimeoutId));
    __privateSet(this, _staleTimeoutId, void 0);
  }
}, clearRefetchInterval_fn = function() {
  if (__privateGet(this, _refetchIntervalId)) {
    clearInterval(__privateGet(this, _refetchIntervalId));
    __privateSet(this, _refetchIntervalId, void 0);
  }
}, updateQuery_fn = function() {
  const query = __privateGet(this, _client2).getQueryCache().build(__privateGet(this, _client2), this.options);
  if (query === __privateGet(this, _currentQuery)) {
    return;
  }
  const prevQuery = __privateGet(this, _currentQuery);
  __privateSet(this, _currentQuery, query);
  __privateSet(this, _currentQueryInitialState, query.state);
  if (this.hasListeners()) {
    prevQuery == null ? void 0 : prevQuery.removeObserver(this);
    query.addObserver(this);
  }
}, notify_fn = function(notifyOptions) {
  notifyManager.batch(() => {
    if (notifyOptions.listeners) {
      this.listeners.forEach((listener) => {
        listener(__privateGet(this, _currentResult));
      });
    }
    __privateGet(this, _client2).getQueryCache().notify({
      query: __privateGet(this, _currentQuery),
      type: "observerResultsUpdated"
    });
  });
}, _j);
function shouldLoadOnMount(query, options) {
  return resolveEnabled(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || query.state.data !== void 0 && shouldFetchOn(query, options, options.refetchOnMount);
}
function shouldFetchOn(query, options, field) {
  if (resolveEnabled(options.enabled, query) !== false) {
    const value = typeof field === "function" ? field(query) : field;
    return value === "always" || value !== false && isStale(query, options);
  }
  return false;
}
function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return (query !== prevQuery || resolveEnabled(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && isStale(query, options);
}
function isStale(query, options) {
  return resolveEnabled(options.enabled, query) !== false && query.isStaleByTime(resolveStaleTime(options.staleTime, query));
}
function shouldAssignObserverCurrentProperties(observer, optimisticResult) {
  if (!shallowEqualObjects(observer.getCurrentResult(), optimisticResult)) {
    return true;
  }
  return false;
}
var QueryClientContext = React.createContext(
  void 0
);
var useQueryClient = (queryClient) => {
  const client = React.useContext(QueryClientContext);
  if (queryClient) {
    return queryClient;
  }
  if (!client) {
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  }
  return client;
};
var QueryClientProvider = ({
  client,
  children
}) => {
  React.useEffect(() => {
    client.mount();
    return () => {
      client.unmount();
    };
  }, [client]);
  return /* @__PURE__ */ jsx(QueryClientContext.Provider, { value: client, children });
};
var IsRestoringContext = React.createContext(false);
var useIsRestoring = () => React.useContext(IsRestoringContext);
IsRestoringContext.Provider;
function createValue() {
  let isReset = false;
  return {
    clearReset: () => {
      isReset = false;
    },
    reset: () => {
      isReset = true;
    },
    isReset: () => {
      return isReset;
    }
  };
}
var QueryErrorResetBoundaryContext = React.createContext(createValue());
var useQueryErrorResetBoundary = () => React.useContext(QueryErrorResetBoundaryContext);
var ensurePreventErrorBoundaryRetry = (options, errorResetBoundary) => {
  if (options.suspense || options.throwOnError || options.experimental_prefetchInRender) {
    if (!errorResetBoundary.isReset()) {
      options.retryOnMount = false;
    }
  }
};
var useClearResetErrorBoundary = (errorResetBoundary) => {
  React.useEffect(() => {
    errorResetBoundary.clearReset();
  }, [errorResetBoundary]);
};
var getHasError = ({
  result,
  errorResetBoundary,
  throwOnError,
  query,
  suspense
}) => {
  return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || shouldThrowError(throwOnError, [result.error, query]));
};
var ensureSuspenseTimers = (defaultedOptions) => {
  const originalStaleTime = defaultedOptions.staleTime;
  if (defaultedOptions.suspense) {
    defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args) => Math.max(originalStaleTime(...args), 1e3) : Math.max(originalStaleTime != null ? originalStaleTime : 1e3, 1e3);
    if (typeof defaultedOptions.gcTime === "number") {
      defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, 1e3);
    }
  }
};
var willFetch = (result, isRestoring) => result.isLoading && result.isFetching && !isRestoring;
var shouldSuspend = (defaultedOptions, result) => (defaultedOptions == null ? void 0 : defaultedOptions.suspense) && result.isPending;
var fetchOptimistic = (defaultedOptions, observer, errorResetBoundary) => observer.fetchOptimistic(defaultedOptions).catch(() => {
  errorResetBoundary.clearReset();
});
function useBaseQuery(options, Observer, queryClient) {
  var _a2, _b2, _c2, _d2, _e2;
  if (process.env.NODE_ENV !== "production") {
    if (typeof options !== "object" || Array.isArray(options)) {
      throw new Error(
        'Bad argument type. Starting with v5, only the "Object" form is allowed when calling query related functions. Please use the error stack to find the culprit call. More info here: https://tanstack.com/query/latest/docs/react/guides/migrating-to-v5#supports-a-single-signature-one-object'
      );
    }
  }
  const client = useQueryClient(queryClient);
  const isRestoring = useIsRestoring();
  const errorResetBoundary = useQueryErrorResetBoundary();
  const defaultedOptions = client.defaultQueryOptions(options);
  (_b2 = (_a2 = client.getDefaultOptions().queries) == null ? void 0 : _a2._experimental_beforeQuery) == null ? void 0 : _b2.call(
    _a2,
    defaultedOptions
  );
  if (process.env.NODE_ENV !== "production") {
    if (!defaultedOptions.queryFn) {
      console.error(
        `[${defaultedOptions.queryHash}]: No queryFn was passed as an option, and no default queryFn was found. The queryFn parameter is only optional when using a default queryFn. More info here: https://tanstack.com/query/latest/docs/framework/react/guides/default-query-function`
      );
    }
  }
  defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
  ensureSuspenseTimers(defaultedOptions);
  ensurePreventErrorBoundaryRetry(defaultedOptions, errorResetBoundary);
  useClearResetErrorBoundary(errorResetBoundary);
  const isNewCacheEntry = !client.getQueryCache().get(defaultedOptions.queryHash);
  const [observer] = React.useState(
    () => new Observer(
      client,
      defaultedOptions
    )
  );
  const result = observer.getOptimisticResult(defaultedOptions);
  const shouldSubscribe = !isRestoring && options.subscribed !== false;
  React.useSyncExternalStore(
    React.useCallback(
      (onStoreChange) => {
        const unsubscribe = shouldSubscribe ? observer.subscribe(notifyManager.batchCalls(onStoreChange)) : noop;
        observer.updateResult();
        return unsubscribe;
      },
      [observer, shouldSubscribe]
    ),
    () => observer.getCurrentResult(),
    () => observer.getCurrentResult()
  );
  React.useEffect(() => {
    observer.setOptions(defaultedOptions);
  }, [defaultedOptions, observer]);
  if (shouldSuspend(defaultedOptions, result)) {
    throw fetchOptimistic(defaultedOptions, observer, errorResetBoundary);
  }
  if (getHasError({
    result,
    errorResetBoundary,
    throwOnError: defaultedOptions.throwOnError,
    query: client.getQueryCache().get(defaultedOptions.queryHash),
    suspense: defaultedOptions.suspense
  })) {
    throw result.error;
  }
  (_d2 = (_c2 = client.getDefaultOptions().queries) == null ? void 0 : _c2._experimental_afterQuery) == null ? void 0 : _d2.call(
    _c2,
    defaultedOptions,
    result
  );
  if (defaultedOptions.experimental_prefetchInRender && !isServer && willFetch(result, isRestoring)) {
    const promise = isNewCacheEntry ? (
      // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
      fetchOptimistic(defaultedOptions, observer, errorResetBoundary)
    ) : (
      // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
      (_e2 = client.getQueryCache().get(defaultedOptions.queryHash)) == null ? void 0 : _e2.promise
    );
    promise == null ? void 0 : promise.catch(noop).finally(() => {
      observer.updateResult();
    });
  }
  return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}
function useQuery(options, queryClient) {
  return useBaseQuery(options, QueryObserver, queryClient);
}
function queryOptions(options) {
  return options;
}
const getMeasWebServerAPILocation = (config) => {
  let host = config.measWebServer;
  try {
    host = `${window.location.origin}/api/`;
  } catch (e) {
    console.error("Failed getting window location", e);
  }
  return host;
};
const buildSubServiceUrl = (service, apiVersion) => {
  const config = getMeasInternalConfig();
  const configurationsMap = config.envBased;
  let mainUrlPart = service === "measWebServer" ? getMeasWebServerAPILocation(configurationsMap) : configurationsMap[service];
  if (apiVersion) {
    mainUrlPart = `${mainUrlPart}${apiVersion}/`;
  }
  return mainUrlPart;
};
const buildUrl$1 = (config) => {
  const {
    service,
    data,
    request,
    apiVersion
  } = config;
  const paramKeys = data ? Object.keys(data) : [];
  const hasParams = paramKeys.length > 0;
  if (!service) {
    throw new Error(`buildUrl no 'service' provided`);
  }
  let url = buildSubServiceUrl(service, apiVersion);
  if (request) {
    url = `${url}${request}`;
  }
  if (hasParams) {
    const paramsList = buildParamsList(paramKeys, data);
    url = `${url}?${paramsList.toString()}`;
  }
  return url;
};
const buildParamsList = (paramKeys, data) => {
  const paramsList = new URLSearchParams();
  paramKeys.forEach((key) => {
    const value = data[key];
    if (value === void 0 || value === null) {
      return;
    }
    if (Array.isArray(value)) {
      return value.forEach((val) => {
        if (val || Number(val) === 0) {
          paramsList.append(key, val);
        }
      });
    }
    return paramsList.set(key, value);
  });
  return paramsList;
};
const buildHeaders$1 = (auth) => {
  const headers = {
    "Content-Type": "application/json; charset=utf-8"
  };
  if (auth !== void 0 && auth !== null) {
    const {
      token,
      siteId,
      clientId,
      clientSecret
    } = auth;
    if (token) {
      headers.Authorization = token;
    }
    if (siteId) {
      headers.SiteId = siteId;
    }
    if (clientId) {
      headers["x-dw-client-id"] = clientId;
    }
    if (clientSecret) {
      headers.GwSecretKey = clientSecret;
    }
  }
  return headers;
};
const collectErrorDetails$1 = (_0) => __async(null, [_0], function* ({
  caughtError,
  requestEndpoint,
  requestUrl,
  response
}) {
  let responseBody;
  let runtimeErrorAsString;
  try {
    if (response) {
      responseBody = yield response.json().catch(() => ({
        customMessage: "No Response Content"
      }));
    }
    if (caughtError) {
      runtimeErrorAsString = caughtError instanceof Error ? caughtError.message : String(caughtError);
    }
  } catch (e) {
    console.warn("Failed parsing response body on Failure", e);
  }
  const errorBody = {
    data: responseBody,
    isResponseHandlingFailed: !response,
    name: "CustomNetworkError",
    message: runtimeErrorAsString || (response == null ? void 0 : response.statusText) || "",
    status: (response == null ? void 0 : response.status) || void 0,
    url: (response == null ? void 0 : response.url) || requestUrl || void 0,
    urlPath: requestEndpoint
  };
  return Promise.reject(errorBody);
});
const NETWORK_HELPERS = {
  buildUrl: buildUrl$1,
  buildHeaders: buildHeaders$1,
  collectErrorDetails: collectErrorDetails$1
};
const {
  buildUrl,
  buildHeaders,
  collectErrorDetails
} = NETWORK_HELPERS;
const fetchGet = (config) => __async(null, null, function* () {
  try {
    const requestUrl = buildUrl(config);
    const response = yield fetch(requestUrl, {
      method: "GET",
      headers: buildHeaders(config.auth),
      signal: config.abortTimeOut ? AbortSignal.timeout(config.abortTimeOut) : void 0
    });
    if (response.ok) {
      return response.json().catch(() => ({
        customMessage: "No JSON content"
      }));
    }
    return collectErrorDetails({
      requestEndpoint: config.request,
      requestUrl,
      response
    });
  } catch (error) {
    return collectErrorDetails({
      caughtError: error,
      requestEndpoint: config.request
    });
  }
});
const fetchPost = (config) => __async(null, null, function* () {
  const {
    service,
    request,
    data,
    auth,
    apiVersion,
    requestMethod
  } = config;
  try {
    const requestUrl = buildUrl({
      service,
      request,
      apiVersion
    });
    const response = yield fetch(requestUrl, {
      method: requestMethod || "POST",
      headers: buildHeaders(auth),
      body: JSON.stringify(data),
      signal: config.abortTimeOut ? AbortSignal.timeout(config.abortTimeOut) : void 0
    });
    if (response.ok) {
      return response.json().catch(() => ({
        customMessage: "No JSON content"
      }));
    }
    return collectErrorDetails({
      requestEndpoint: config.request,
      requestUrl,
      response
    });
  } catch (error) {
    return collectErrorDetails({
      requestEndpoint: config.request,
      caughtError: error
    });
  }
});
const getCountryRegion = (config) => {
  const {
    countryCode
  } = config;
  return fetchGet({
    service: "measurementsBffUrl",
    apiVersion: "v1",
    request: "SizeChart/CountryRegion",
    data: {
      countryCode
    }
  });
};
const getProductFits = (config) => {
  const {
    productType,
    countryCode
  } = config;
  return fetchGet({
    service: "measurementsBffUrl",
    apiVersion: "v1",
    request: "SizePassport/Product/Fits",
    data: {
      productTypeId: productType,
      countryCode
    }
  });
};
const getSizeGroups = (config) => {
  const {
    productType,
    countryCode
  } = config;
  return fetchGet({
    service: "measurementsBffUrl",
    apiVersion: "v2",
    request: "SizePassport/Product/SizeGroups",
    data: {
      productTypeId: productType,
      countryCode
    }
  });
};
const getProductMeasurements = ({
  productType
}) => {
  return fetchGet({
    service: "measurementsBffUrl",
    apiVersion: "v1",
    request: "SizePassport/Product/Measurements",
    data: {
      productTypeId: productType
    }
  });
};
const getProductMeasurementsAndAdjustments = ({
  hideFallbackAlterations = false,
  productType
}) => {
  return fetchGet({
    service: "measurementsBffUrl",
    apiVersion: "v1",
    request: "SizePassport/Product/Fallback-Measurements",
    data: {
      hideFallbackAlterations: String(hideFallbackAlterations),
      productTypeId: productType
    }
  });
};
const getFitMeasurements = (config) => {
  const {
    productType,
    fitId,
    sizeId
  } = config;
  return fetchGet({
    service: "measurementsBffUrl",
    apiVersion: "v1",
    request: "SizePassport/Product/FitMeasurements",
    data: {
      productTypeId: productType,
      fitId,
      sizeId
    }
  });
};
const getProductTypeByCode = (productCode) => {
  return fetchGet({
    service: "measurementsBffUrl",
    apiVersion: "v1",
    request: `ProductCodes/${productCode}/product-type`
  });
};
const getProductInfoByCode = (productCode) => {
  return fetchGet({
    service: "sizePassportUrl",
    apiVersion: "v1",
    request: "RtwProductFits",
    data: {
      productCode
    }
  });
};
const getRtwTailorAlterationInstructions = ({
  accountNr,
  alterationId,
  calculateCircumference = false,
  epc,
  languageCode,
  sizePassportIds,
  token
}) => {
  return fetchGet({
    service: "sizePassportUrl",
    apiVersion: "v2",
    request: "RtwAlterations/AlterationInstructions",
    auth: {
      token
    },
    data: {
      accountNr,
      alterationId,
      calculateCircumference: String(calculateCircumference),
      epc,
      lang: languageCode.toLowerCase(),
      sizePassportIds
    }
  });
};
const getCircumferenceMeasurements = (productTypeId) => {
  return fetchGet({
    service: "measurementsBffUrl",
    apiVersion: "v1",
    request: "SizePassport/Product/CircumferenceMeasurements",
    data: {
      productTypeId
    }
  });
};
const getCustomerServiceInfo = ({
  measurementTags,
  sizePassportId
}) => {
  return fetchGet({
    service: "sizePassportUrl",
    apiVersion: "v1",
    request: `SizePassports/CustomerService/${sizePassportId}`,
    data: {
      measurementTags
    }
  });
};
const getCustomerRtwProfiles = ({
  accountNr,
  fitId,
  cmlFitId,
  countryCode,
  productCode,
  productTypeId,
  siteId,
  token,
  version: version2 = "v1"
}) => {
  return fetchGet({
    service: "sizePassportPublicUrl",
    apiVersion: version2,
    request: `SizePassportProfile/RtwProfiles`,
    auth: {
      siteId,
      token
    },
    data: {
      accountNr,
      fitId,
      cmlFitId,
      countryCode,
      productCode,
      productTypeId
    },
    abortTimeOut: 4e3
  });
};
const getRecommendedCustomerProfiles = ({
  accountNr,
  countryCode,
  token
}) => {
  return fetchGet({
    service: "sizePassportUrl",
    apiVersion: "v1",
    request: `SizePassportProfile/RecommendedProfiles`,
    auth: {
      token
    },
    data: {
      accountNr,
      countryCode
    }
  });
};
const getCircumferenceMeasurementsPerProductTypes = (productTypeIds) => {
  return fetchGet({
    service: "measurementsBffUrl",
    apiVersion: "v1",
    request: "SizePassport/Product/CircumferenceMeasurementsPerProductTypes",
    data: {
      productTypeIds
    }
  });
};
const getMeasurementsPerProductTypes = ({
  countryCode,
  productTypeIds
}) => {
  return fetchGet({
    service: "measurementsBffUrl",
    apiVersion: "v1",
    request: "SizePassport/Product/MeasurementsPerProductTypes",
    data: {
      countryCode,
      productTypeIds
    }
  });
};
export {
  ensureSuspenseTimers as $,
  getCountryRegion as A,
  getMeasInternalConfig as B,
  CommonConfigProvider as C,
  trackDatadogLogs as D,
  getIsDatadogLogsInitialized as E,
  createCustomDatadogLogger as F,
  ConfigStateContext as G,
  getProductTypeByCode as H,
  getCustomerRtwProfiles as I,
  useQueryClient as J,
  v4 as K,
  shallowEqualObjects as L,
  hashKey as M,
  getDefaultState as N,
  notifyManager as O,
  noop as P,
  QueryClient as Q,
  shouldThrowError as R,
  Subscribable as S,
  getDatadogUser as T,
  replaceEqualDeep as U,
  QueryObserver as V,
  infiniteQueryBehavior as W,
  hasPreviousPage as X,
  hasNextPage as Y,
  useIsRestoring as Z,
  useQueryErrorResetBoundary as _,
  QueryClientProvider as a,
  ensurePreventErrorBoundaryRetry as a0,
  useClearResetErrorBoundary as a1,
  shouldSuspend as a2,
  fetchOptimistic as a3,
  willFetch as a4,
  getHasError as a5,
  useBaseQuery as a6,
  getRtwTailorAlterationInstructions as a7,
  initDatadog$1 as a8,
  getDatadogRum as a9,
  getMeasEnvBasedConfig as b,
  customMessageLogger as c,
  distExports as d,
  getProductInfoByCode as e,
  fetchGet as f,
  getMeasClientVersion as g,
  fetchPost as h,
  useMainConfigContext as i,
  initDatadog as j,
  getDefaultExportFromCjs as k,
  getIsDatadogInitialized as l,
  getCircumferenceMeasurementsPerProductTypes as m,
  getMeasurementsPerProductTypes as n,
  getRecommendedCustomerProfiles as o,
  getCustomerServiceInfo as p,
  queryOptions as q,
  getSizeGroups as r,
  getCircumferenceMeasurements as s,
  trackDatadogActions as t,
  useQuery as u,
  getProductMeasurementsAndAdjustments as v,
  getProductMeasurements as w,
  getFitMeasurements as x,
  customDevOnlyLogger as y,
  getProductFits as z
};
